/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ShellIndexRouteImport } from './routes/_shell/index'
import { Route as ShellAdminsRouteImport } from './routes/_shell/admins'
import { Route as ShellAgentsRouteImport } from './routes/_shell/agents'
import { Route as ShellAiCostsRouteImport } from './routes/_shell/ai-costs'
import { Route as ShellAnnouncementBarRouteImport } from './routes/_shell/announcement-bar'
import { Route as ShellAuditRouteImport } from './routes/_shell/audit'
import { Route as ShellAutomationsRouteImport } from './routes/_shell/automations'
import { Route as ShellBillingRulesRouteImport } from './routes/_shell/billing-rules'
import { Route as ShellBrandsRouteImport } from './routes/_shell/brands'
import { Route as ShellBrokerChangesRouteImport } from './routes/_shell/broker-changes'
import { Route as ShellBrokerOverviewRouteImport } from './routes/_shell/broker-overview'
import { Route as ShellBrokerSyncRouteImport } from './routes/_shell/broker-sync'
import { Route as ShellCampaignRouteImport } from './routes/_shell/campaign'
import { Route as ShellCampaignsRouteImport } from './routes/_shell/campaigns'
import { Route as ShellCarrierReconcileRouteImport } from './routes/_shell/carrier-reconcile'
import { Route as ShellChangelogsRouteImport } from './routes/_shell/changelogs'
import { Route as ShellCheckRateRouteImport } from './routes/_shell/check-rate'
import { Route as ShellCommFilesRouteImport } from './routes/_shell/comm-files'
import { Route as ShellCommTemplatesRouteImport } from './routes/_shell/comm-templates'
import { Route as ShellCommunicationsRouteImport } from './routes/_shell/communications'
import { Route as ShellContactConsentsRouteImport } from './routes/_shell/contact-consents'
import { Route as ShellConversationsRouteImport } from './routes/_shell/conversations'
import { Route as ShellCredentialGroupsRouteImport } from './routes/_shell/credential-groups'
import { Route as ShellCreditCardsRouteImport } from './routes/_shell/credit-cards'
import { Route as ShellDeliverabilityRouteImport } from './routes/_shell/deliverability'
import { Route as ShellDispatchesRouteImport } from './routes/_shell/dispatches'
import { Route as ShellDistributionsRouteImport } from './routes/_shell/distributions'
import { Route as ShellEmailMessagesRouteImport } from './routes/_shell/email-messages'
import { Route as ShellGeocodesRouteImport } from './routes/_shell/geocodes'
import { Route as ShellGroupLoadboardRouteImport } from './routes/_shell/group-loadboard'
import { Route as ShellGroupSubscriptionsRouteImport } from './routes/_shell/group-subscriptions'
import { Route as ShellHomeRouteImport } from './routes/_shell/home'
import { Route as ShellImportRouteImport } from './routes/_shell/import'
import { Route as ShellInboxRouteImport } from './routes/_shell/inbox'
import { Route as ShellInboxesRouteImport } from './routes/_shell/inboxes'
import { Route as ShellInsightsRouteImport } from './routes/_shell/insights'
import { Route as ShellIntegrationsRouteImport } from './routes/_shell/integrations'
import { Route as ShellLeadSubmissionsRouteImport } from './routes/_shell/lead-submissions'
import { Route as ShellLeadsRouteImport } from './routes/_shell/leads'
import { Route as ShellLoadboardsRouteImport } from './routes/_shell/loadboards'
import { Route as ShellLogsRouteImport } from './routes/_shell/logs'
import { Route as ShellMailAccountsRouteImport } from './routes/_shell/mail-accounts'
import { Route as ShellMailPricingRouteImport } from './routes/_shell/mail-pricing'
import { Route as ShellMailSettingsRouteImport } from './routes/_shell/mail-settings'
import { Route as ShellMassCallDetectionsRouteImport } from './routes/_shell/mass-call-detections'
import { Route as ShellMassJobsRouteImport } from './routes/_shell/mass-jobs'
import { Route as ShellMessagingProfilesRouteImport } from './routes/_shell/messaging-profiles'
import { Route as ShellModelsRouteImport } from './routes/_shell/models'
import { Route as ShellNotificationsRouteImport } from './routes/_shell/notifications'
import { Route as ShellNumberEventsRouteImport } from './routes/_shell/number-events'
import { Route as ShellNumberOrdersRouteImport } from './routes/_shell/number-orders'
import { Route as ShellNumbersRouteImport } from './routes/_shell/numbers'
import { Route as ShellOrderFeedbackRouteImport } from './routes/_shell/order-feedback'
import { Route as ShellOrdersRouteImport } from './routes/_shell/orders'
import { Route as ShellOrgAiRouteImport } from './routes/_shell/org-ai'
import { Route as ShellPaymentMethodsRouteImport } from './routes/_shell/payment-methods'
import { Route as ShellPaymentsRouteImport } from './routes/_shell/payments'
import { Route as ShellPlansRouteImport } from './routes/_shell/plans'
import { Route as ShellPlaygroundRouteImport } from './routes/_shell/playground'
import { Route as ShellPortingOrdersRouteImport } from './routes/_shell/porting-orders'
import { Route as ShellPricingUsageRouteImport } from './routes/_shell/pricing-usage'
import { Route as ShellPromotionsRouteImport } from './routes/_shell/promotions'
import { Route as ShellProviderSwitchesRouteImport } from './routes/_shell/provider-switches'
import { Route as ShellQuietHoursRouteImport } from './routes/_shell/quiet-hours'
import { Route as ShellQuotesRouteImport } from './routes/_shell/quotes'
import { Route as ShellSecurityRouteImport } from './routes/_shell/security'
import { Route as ShellSenderHealthRouteImport } from './routes/_shell/sender-health'
import { Route as ShellShipmentEventsRouteImport } from './routes/_shell/shipment-events'
import { Route as ShellShipmentReasonsRouteImport } from './routes/_shell/shipment-reasons'
import { Route as ShellSipRouteImport } from './routes/_shell/sip'
import { Route as ShellSkillsRouteImport } from './routes/_shell/skills'
import { Route as ShellSmsMessagesRouteImport } from './routes/_shell/sms-messages'
import { Route as ShellSpamControlsRouteImport } from './routes/_shell/spam-controls'
import { Route as ShellSpekoNumbersRouteImport } from './routes/_shell/speko-numbers'
import { Route as ShellSubscriptionInvoicesRouteImport } from './routes/_shell/subscription-invoices'
import { Route as ShellSubscriptionsRouteImport } from './routes/_shell/subscriptions'
import { Route as ShellTagsRouteImport } from './routes/_shell/tags'
import { Route as ShellTasksRouteImport } from './routes/_shell/tasks'
import { Route as ShellTextingAutomationRouteImport } from './routes/_shell/texting-automation'
import { Route as ShellThecargoMailRouteImport } from './routes/_shell/thecargo-mail'
import { Route as ShellTipPresetsRouteImport } from './routes/_shell/tip-presets'
import { Route as ShellToolsRouteImport } from './routes/_shell/tools'
import { Route as ShellVoicesRouteImport } from './routes/_shell/voices'
import { Route as ShellVoipRouteImport } from './routes/_shell/voip'
import { Route as ShellWalletTopupsRouteImport } from './routes/_shell/wallet-topups'
import { Route as ShellWebhookEventsRouteImport } from './routes/_shell/webhook-events'
import { Route as LoginPasskeyRouteImport } from './routes/login_.passkey'
import { Route as LoginRecoveryRouteImport } from './routes/login_.recovery'
import { Route as ShellAiRatesIndexRouteImport } from './routes/_shell/ai-rates.index'
import { Route as ShellAiRatesRateIdRouteImport } from './routes/_shell/ai-rates.$rateId'
import { Route as ShellAnnouncementsIndexRouteImport } from './routes/_shell/announcements.index'
import { Route as ShellAnnouncementsCreateRouteImport } from './routes/_shell/announcements.create'
import { Route as ShellBlogPostsIndexRouteImport } from './routes/_shell/blog-posts.index'
import { Route as ShellBlogPostsPostIdRouteImport } from './routes/_shell/blog-posts.$postId'
import { Route as ShellBrokersIndexRouteImport } from './routes/_shell/brokers.index'
import { Route as ShellBrokersUsdotRouteImport } from './routes/_shell/brokers.$usdot'
import { Route as ShellCallsIndexRouteImport } from './routes/_shell/calls.index'
import { Route as ShellCallsCallIdRouteImport } from './routes/_shell/calls.$callId'
import { Route as ShellCampaignIndexRouteImport } from './routes/_shell/campaign.index'
import { Route as ShellCampaignCampaignIdRouteImport } from './routes/_shell/campaign.$campaignId'
import { Route as ShellCarriersIndexRouteImport } from './routes/_shell/carriers.index'
import { Route as ShellCarriersCarrierIdRouteImport } from './routes/_shell/carriers.$carrierId'
import { Route as ShellContractTemplatesIndexRouteImport } from './routes/_shell/contract-templates.index'
import { Route as ShellContractTemplatesTemplateIdRouteImport } from './routes/_shell/contract-templates.$templateId'
import { Route as ShellCustomersIndexRouteImport } from './routes/_shell/customers.index'
import { Route as ShellCustomersCustomerIdRouteImport } from './routes/_shell/customers.$customerId'
import { Route as ShellFmcsaCarriersIndexRouteImport } from './routes/_shell/fmcsa-carriers.index'
import { Route as ShellFmcsaCarriersUsdotRouteImport } from './routes/_shell/fmcsa-carriers.$usdot'
import { Route as ShellLeadsLeadIdRouteImport } from './routes/_shell/leads.$leadId'
import { Route as ShellMessagingPricesIndexRouteImport } from './routes/_shell/messaging-prices.index'
import { Route as ShellMessagingPricesPriceIdRouteImport } from './routes/_shell/messaging-prices.$priceId'
import { Route as ShellOrdersOrderIdRouteImport } from './routes/_shell/orders.$orderId'
import { Route as ShellOrganizationsIndexRouteImport } from './routes/_shell/organizations.index'
import { Route as ShellOrganizationsOrganizationIdRouteImport } from './routes/_shell/organizations.$organizationId'
import { Route as ShellProvidersIndexRouteImport } from './routes/_shell/providers.index'
import { Route as ShellProvidersProviderIdRouteImport } from './routes/_shell/providers.$providerId'
import { Route as ShellQuotesQuoteIdRouteImport } from './routes/_shell/quotes.$quoteId'
import { Route as ShellRoleTemplatesIndexRouteImport } from './routes/_shell/role-templates.index'
import { Route as ShellRoleTemplatesTemplateIdRouteImport } from './routes/_shell/role-templates.$templateId'
import { Route as ShellRolesIndexRouteImport } from './routes/_shell/roles.index'
import { Route as ShellRolesRoleIdRouteImport } from './routes/_shell/roles.$roleId'
import { Route as ShellShipmentsIndexRouteImport } from './routes/_shell/shipments.index'
import { Route as ShellShipmentsShipmentIdRouteImport } from './routes/_shell/shipments.$shipmentId'
import { Route as ShellTeamsIndexRouteImport } from './routes/_shell/teams.index'
import { Route as ShellTeamsTeamIdRouteImport } from './routes/_shell/teams.$teamId'
import { Route as ShellUsersIndexRouteImport } from './routes/_shell/users.index'
import { Route as ShellUsersUserIdRouteImport } from './routes/_shell/users.$userId'
import { Route as ShellLeadsLeadIdIndexRouteImport } from './routes/_shell/leads.$leadId.index'
import { Route as ShellLeadsLeadIdConvertRouteImport } from './routes/_shell/leads.$leadId.convert'
import { Route as ShellLeadsLeadIdEditRouteImport } from './routes/_shell/leads.$leadId.edit'
import { Route as ShellOrdersOrderIdIndexRouteImport } from './routes/_shell/orders.$orderId.index'
import { Route as ShellOrdersOrderIdDispatchRouteImport } from './routes/_shell/orders.$orderId.dispatch'
import { Route as ShellOrdersOrderIdEditRouteImport } from './routes/_shell/orders.$orderId.edit'
import { Route as ShellOrganizationsOrganizationIdEditRouteImport } from './routes/_shell/organizations.$organizationId_.edit'
import { Route as ShellQuotesQuoteIdIndexRouteImport } from './routes/_shell/quotes.$quoteId.index'
import { Route as ShellQuotesQuoteIdConvertRouteImport } from './routes/_shell/quotes.$quoteId.convert'
import { Route as ShellQuotesQuoteIdEditRouteImport } from './routes/_shell/quotes.$quoteId.edit'
import { Route as ShellShipmentsShipmentIdEditRouteImport } from './routes/_shell/shipments_.$shipmentId.edit'

const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellIndexRoute = ShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAdminsRoute = ShellAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAgentsRoute = ShellAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAiCostsRoute = ShellAiCostsRouteImport.update({
  id: '/ai-costs',
  path: '/ai-costs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAnnouncementBarRoute = ShellAnnouncementBarRouteImport.update({
  id: '/announcement-bar',
  path: '/announcement-bar',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAuditRoute = ShellAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAutomationsRoute = ShellAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBillingRulesRoute = ShellBillingRulesRouteImport.update({
  id: '/billing-rules',
  path: '/billing-rules',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBrandsRoute = ShellBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBrokerChangesRoute = ShellBrokerChangesRouteImport.update({
  id: '/broker-changes',
  path: '/broker-changes',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBrokerOverviewRoute = ShellBrokerOverviewRouteImport.update({
  id: '/broker-overview',
  path: '/broker-overview',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBrokerSyncRoute = ShellBrokerSyncRouteImport.update({
  id: '/broker-sync',
  path: '/broker-sync',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCampaignRoute = ShellCampaignRouteImport.update({
  id: '/campaign',
  path: '/campaign',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCampaignsRoute = ShellCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCarrierReconcileRoute = ShellCarrierReconcileRouteImport.update({
  id: '/carrier-reconcile',
  path: '/carrier-reconcile',
  getParentRoute: () => ShellRoute,
} as any)
const ShellChangelogsRoute = ShellChangelogsRouteImport.update({
  id: '/changelogs',
  path: '/changelogs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCheckRateRoute = ShellCheckRateRouteImport.update({
  id: '/check-rate',
  path: '/check-rate',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCommFilesRoute = ShellCommFilesRouteImport.update({
  id: '/comm-files',
  path: '/comm-files',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCommTemplatesRoute = ShellCommTemplatesRouteImport.update({
  id: '/comm-templates',
  path: '/comm-templates',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCommunicationsRoute = ShellCommunicationsRouteImport.update({
  id: '/communications',
  path: '/communications',
  getParentRoute: () => ShellRoute,
} as any)
const ShellContactConsentsRoute = ShellContactConsentsRouteImport.update({
  id: '/contact-consents',
  path: '/contact-consents',
  getParentRoute: () => ShellRoute,
} as any)
const ShellConversationsRoute = ShellConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCredentialGroupsRoute = ShellCredentialGroupsRouteImport.update({
  id: '/credential-groups',
  path: '/credential-groups',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCreditCardsRoute = ShellCreditCardsRouteImport.update({
  id: '/credit-cards',
  path: '/credit-cards',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDeliverabilityRoute = ShellDeliverabilityRouteImport.update({
  id: '/deliverability',
  path: '/deliverability',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDispatchesRoute = ShellDispatchesRouteImport.update({
  id: '/dispatches',
  path: '/dispatches',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDistributionsRoute = ShellDistributionsRouteImport.update({
  id: '/distributions',
  path: '/distributions',
  getParentRoute: () => ShellRoute,
} as any)
const ShellEmailMessagesRoute = ShellEmailMessagesRouteImport.update({
  id: '/email-messages',
  path: '/email-messages',
  getParentRoute: () => ShellRoute,
} as any)
const ShellGeocodesRoute = ShellGeocodesRouteImport.update({
  id: '/geocodes',
  path: '/geocodes',
  getParentRoute: () => ShellRoute,
} as any)
const ShellGroupLoadboardRoute = ShellGroupLoadboardRouteImport.update({
  id: '/group-loadboard',
  path: '/group-loadboard',
  getParentRoute: () => ShellRoute,
} as any)
const ShellGroupSubscriptionsRoute = ShellGroupSubscriptionsRouteImport.update({
  id: '/group-subscriptions',
  path: '/group-subscriptions',
  getParentRoute: () => ShellRoute,
} as any)
const ShellHomeRoute = ShellHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ShellRoute,
} as any)
const ShellImportRoute = ShellImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => ShellRoute,
} as any)
const ShellInboxRoute = ShellInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => ShellRoute,
} as any)
const ShellInboxesRoute = ShellInboxesRouteImport.update({
  id: '/inboxes',
  path: '/inboxes',
  getParentRoute: () => ShellRoute,
} as any)
const ShellInsightsRoute = ShellInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => ShellRoute,
} as any)
const ShellIntegrationsRoute = ShellIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLeadSubmissionsRoute = ShellLeadSubmissionsRouteImport.update({
  id: '/lead-submissions',
  path: '/lead-submissions',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLeadsRoute = ShellLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLoadboardsRoute = ShellLoadboardsRouteImport.update({
  id: '/loadboards',
  path: '/loadboards',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLogsRoute = ShellLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMailAccountsRoute = ShellMailAccountsRouteImport.update({
  id: '/mail-accounts',
  path: '/mail-accounts',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMailPricingRoute = ShellMailPricingRouteImport.update({
  id: '/mail-pricing',
  path: '/mail-pricing',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMailSettingsRoute = ShellMailSettingsRouteImport.update({
  id: '/mail-settings',
  path: '/mail-settings',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMassCallDetectionsRoute = ShellMassCallDetectionsRouteImport.update({
  id: '/mass-call-detections',
  path: '/mass-call-detections',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMassJobsRoute = ShellMassJobsRouteImport.update({
  id: '/mass-jobs',
  path: '/mass-jobs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMessagingProfilesRoute = ShellMessagingProfilesRouteImport.update({
  id: '/messaging-profiles',
  path: '/messaging-profiles',
  getParentRoute: () => ShellRoute,
} as any)
const ShellModelsRoute = ShellModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => ShellRoute,
} as any)
const ShellNotificationsRoute = ShellNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => ShellRoute,
} as any)
const ShellNumberEventsRoute = ShellNumberEventsRouteImport.update({
  id: '/number-events',
  path: '/number-events',
  getParentRoute: () => ShellRoute,
} as any)
const ShellNumberOrdersRoute = ShellNumberOrdersRouteImport.update({
  id: '/number-orders',
  path: '/number-orders',
  getParentRoute: () => ShellRoute,
} as any)
const ShellNumbersRoute = ShellNumbersRouteImport.update({
  id: '/numbers',
  path: '/numbers',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrderFeedbackRoute = ShellOrderFeedbackRouteImport.update({
  id: '/order-feedback',
  path: '/order-feedback',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrdersRoute = ShellOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrgAiRoute = ShellOrgAiRouteImport.update({
  id: '/org-ai',
  path: '/org-ai',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPaymentMethodsRoute = ShellPaymentMethodsRouteImport.update({
  id: '/payment-methods',
  path: '/payment-methods',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPaymentsRoute = ShellPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPlansRoute = ShellPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPlaygroundRoute = ShellPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPortingOrdersRoute = ShellPortingOrdersRouteImport.update({
  id: '/porting-orders',
  path: '/porting-orders',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPricingUsageRoute = ShellPricingUsageRouteImport.update({
  id: '/pricing-usage',
  path: '/pricing-usage',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPromotionsRoute = ShellPromotionsRouteImport.update({
  id: '/promotions',
  path: '/promotions',
  getParentRoute: () => ShellRoute,
} as any)
const ShellProviderSwitchesRoute = ShellProviderSwitchesRouteImport.update({
  id: '/provider-switches',
  path: '/provider-switches',
  getParentRoute: () => ShellRoute,
} as any)
const ShellQuietHoursRoute = ShellQuietHoursRouteImport.update({
  id: '/quiet-hours',
  path: '/quiet-hours',
  getParentRoute: () => ShellRoute,
} as any)
const ShellQuotesRoute = ShellQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSecurityRoute = ShellSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSenderHealthRoute = ShellSenderHealthRouteImport.update({
  id: '/sender-health',
  path: '/sender-health',
  getParentRoute: () => ShellRoute,
} as any)
const ShellShipmentEventsRoute = ShellShipmentEventsRouteImport.update({
  id: '/shipment-events',
  path: '/shipment-events',
  getParentRoute: () => ShellRoute,
} as any)
const ShellShipmentReasonsRoute = ShellShipmentReasonsRouteImport.update({
  id: '/shipment-reasons',
  path: '/shipment-reasons',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSipRoute = ShellSipRouteImport.update({
  id: '/sip',
  path: '/sip',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSkillsRoute = ShellSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSmsMessagesRoute = ShellSmsMessagesRouteImport.update({
  id: '/sms-messages',
  path: '/sms-messages',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSpamControlsRoute = ShellSpamControlsRouteImport.update({
  id: '/spam-controls',
  path: '/spam-controls',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSpekoNumbersRoute = ShellSpekoNumbersRouteImport.update({
  id: '/speko-numbers',
  path: '/speko-numbers',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSubscriptionInvoicesRoute =
  ShellSubscriptionInvoicesRouteImport.update({
    id: '/subscription-invoices',
    path: '/subscription-invoices',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellSubscriptionsRoute = ShellSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTagsRoute = ShellTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTasksRoute = ShellTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTextingAutomationRoute = ShellTextingAutomationRouteImport.update({
  id: '/texting-automation',
  path: '/texting-automation',
  getParentRoute: () => ShellRoute,
} as any)
const ShellThecargoMailRoute = ShellThecargoMailRouteImport.update({
  id: '/thecargo-mail',
  path: '/thecargo-mail',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTipPresetsRoute = ShellTipPresetsRouteImport.update({
  id: '/tip-presets',
  path: '/tip-presets',
  getParentRoute: () => ShellRoute,
} as any)
const ShellToolsRoute = ShellToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => ShellRoute,
} as any)
const ShellVoicesRoute = ShellVoicesRouteImport.update({
  id: '/voices',
  path: '/voices',
  getParentRoute: () => ShellRoute,
} as any)
const ShellVoipRoute = ShellVoipRouteImport.update({
  id: '/voip',
  path: '/voip',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWalletTopupsRoute = ShellWalletTopupsRouteImport.update({
  id: '/wallet-topups',
  path: '/wallet-topups',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWebhookEventsRoute = ShellWebhookEventsRouteImport.update({
  id: '/webhook-events',
  path: '/webhook-events',
  getParentRoute: () => ShellRoute,
} as any)
const LoginPasskeyRoute = LoginPasskeyRouteImport.update({
  id: '/login_/passkey',
  path: '/login/passkey',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRecoveryRoute = LoginRecoveryRouteImport.update({
  id: '/login_/recovery',
  path: '/login/recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellAiRatesIndexRoute = ShellAiRatesIndexRouteImport.update({
  id: '/ai-rates/',
  path: '/ai-rates/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAiRatesRateIdRoute = ShellAiRatesRateIdRouteImport.update({
  id: '/ai-rates/$rateId',
  path: '/ai-rates/$rateId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAnnouncementsIndexRoute = ShellAnnouncementsIndexRouteImport.update({
  id: '/announcements/',
  path: '/announcements/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAnnouncementsCreateRoute =
  ShellAnnouncementsCreateRouteImport.update({
    id: '/announcements/create',
    path: '/announcements/create',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellBlogPostsIndexRoute = ShellBlogPostsIndexRouteImport.update({
  id: '/blog-posts/',
  path: '/blog-posts/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBlogPostsPostIdRoute = ShellBlogPostsPostIdRouteImport.update({
  id: '/blog-posts/$postId',
  path: '/blog-posts/$postId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBrokersIndexRoute = ShellBrokersIndexRouteImport.update({
  id: '/brokers/',
  path: '/brokers/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBrokersUsdotRoute = ShellBrokersUsdotRouteImport.update({
  id: '/brokers/$usdot',
  path: '/brokers/$usdot',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCallsIndexRoute = ShellCallsIndexRouteImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCallsCallIdRoute = ShellCallsCallIdRouteImport.update({
  id: '/calls/$callId',
  path: '/calls/$callId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCampaignIndexRoute = ShellCampaignIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellCampaignRoute,
} as any)
const ShellCampaignCampaignIdRoute = ShellCampaignCampaignIdRouteImport.update({
  id: '/$campaignId',
  path: '/$campaignId',
  getParentRoute: () => ShellCampaignRoute,
} as any)
const ShellCarriersIndexRoute = ShellCarriersIndexRouteImport.update({
  id: '/carriers/',
  path: '/carriers/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCarriersCarrierIdRoute = ShellCarriersCarrierIdRouteImport.update({
  id: '/carriers/$carrierId',
  path: '/carriers/$carrierId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellContractTemplatesIndexRoute =
  ShellContractTemplatesIndexRouteImport.update({
    id: '/contract-templates/',
    path: '/contract-templates/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellContractTemplatesTemplateIdRoute =
  ShellContractTemplatesTemplateIdRouteImport.update({
    id: '/contract-templates/$templateId',
    path: '/contract-templates/$templateId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellCustomersIndexRoute = ShellCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCustomersCustomerIdRoute =
  ShellCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellFmcsaCarriersIndexRoute = ShellFmcsaCarriersIndexRouteImport.update({
  id: '/fmcsa-carriers/',
  path: '/fmcsa-carriers/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFmcsaCarriersUsdotRoute = ShellFmcsaCarriersUsdotRouteImport.update({
  id: '/fmcsa-carriers/$usdot',
  path: '/fmcsa-carriers/$usdot',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLeadsLeadIdRoute = ShellLeadsLeadIdRouteImport.update({
  id: '/$leadId',
  path: '/$leadId',
  getParentRoute: () => ShellLeadsRoute,
} as any)
const ShellMessagingPricesIndexRoute =
  ShellMessagingPricesIndexRouteImport.update({
    id: '/messaging-prices/',
    path: '/messaging-prices/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellMessagingPricesPriceIdRoute =
  ShellMessagingPricesPriceIdRouteImport.update({
    id: '/messaging-prices/$priceId',
    path: '/messaging-prices/$priceId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellOrdersOrderIdRoute = ShellOrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => ShellOrdersRoute,
} as any)
const ShellOrganizationsIndexRoute = ShellOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrganizationsOrganizationIdRoute =
  ShellOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellProvidersIndexRoute = ShellProvidersIndexRouteImport.update({
  id: '/providers/',
  path: '/providers/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellProvidersProviderIdRoute =
  ShellProvidersProviderIdRouteImport.update({
    id: '/providers/$providerId',
    path: '/providers/$providerId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellQuotesQuoteIdRoute = ShellQuotesQuoteIdRouteImport.update({
  id: '/$quoteId',
  path: '/$quoteId',
  getParentRoute: () => ShellQuotesRoute,
} as any)
const ShellRoleTemplatesIndexRoute = ShellRoleTemplatesIndexRouteImport.update({
  id: '/role-templates/',
  path: '/role-templates/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRoleTemplatesTemplateIdRoute =
  ShellRoleTemplatesTemplateIdRouteImport.update({
    id: '/role-templates/$templateId',
    path: '/role-templates/$templateId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellRolesIndexRoute = ShellRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRolesRoleIdRoute = ShellRolesRoleIdRouteImport.update({
  id: '/roles/$roleId',
  path: '/roles/$roleId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellShipmentsIndexRoute = ShellShipmentsIndexRouteImport.update({
  id: '/shipments/',
  path: '/shipments/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellShipmentsShipmentIdRoute =
  ShellShipmentsShipmentIdRouteImport.update({
    id: '/shipments/$shipmentId',
    path: '/shipments/$shipmentId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellTeamsIndexRoute = ShellTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTeamsTeamIdRoute = ShellTeamsTeamIdRouteImport.update({
  id: '/teams/$teamId',
  path: '/teams/$teamId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellUsersIndexRoute = ShellUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellUsersUserIdRoute = ShellUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLeadsLeadIdIndexRoute = ShellLeadsLeadIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellLeadsLeadIdRoute,
} as any)
const ShellLeadsLeadIdConvertRoute = ShellLeadsLeadIdConvertRouteImport.update({
  id: '/convert',
  path: '/convert',
  getParentRoute: () => ShellLeadsLeadIdRoute,
} as any)
const ShellLeadsLeadIdEditRoute = ShellLeadsLeadIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ShellLeadsLeadIdRoute,
} as any)
const ShellOrdersOrderIdIndexRoute = ShellOrdersOrderIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellOrdersOrderIdRoute,
} as any)
const ShellOrdersOrderIdDispatchRoute =
  ShellOrdersOrderIdDispatchRouteImport.update({
    id: '/dispatch',
    path: '/dispatch',
    getParentRoute: () => ShellOrdersOrderIdRoute,
  } as any)
const ShellOrdersOrderIdEditRoute = ShellOrdersOrderIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ShellOrdersOrderIdRoute,
} as any)
const ShellOrganizationsOrganizationIdEditRoute =
  ShellOrganizationsOrganizationIdEditRouteImport.update({
    id: '/organizations/$organizationId_/edit',
    path: '/organizations/$organizationId/edit',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellQuotesQuoteIdIndexRoute = ShellQuotesQuoteIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellQuotesQuoteIdRoute,
} as any)
const ShellQuotesQuoteIdConvertRoute =
  ShellQuotesQuoteIdConvertRouteImport.update({
    id: '/convert',
    path: '/convert',
    getParentRoute: () => ShellQuotesQuoteIdRoute,
  } as any)
const ShellQuotesQuoteIdEditRoute = ShellQuotesQuoteIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ShellQuotesQuoteIdRoute,
} as any)
const ShellShipmentsShipmentIdEditRoute =
  ShellShipmentsShipmentIdEditRouteImport.update({
    id: '/shipments_/$shipmentId/edit',
    path: '/shipments/$shipmentId/edit',
    getParentRoute: () => ShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ShellIndexRoute
  '/login': typeof LoginRoute
  '/admins': typeof ShellAdminsRoute
  '/agents': typeof ShellAgentsRoute
  '/ai-costs': typeof ShellAiCostsRoute
  '/announcement-bar': typeof ShellAnnouncementBarRoute
  '/audit': typeof ShellAuditRoute
  '/automations': typeof ShellAutomationsRoute
  '/billing-rules': typeof ShellBillingRulesRoute
  '/brands': typeof ShellBrandsRoute
  '/broker-changes': typeof ShellBrokerChangesRoute
  '/broker-overview': typeof ShellBrokerOverviewRoute
  '/broker-sync': typeof ShellBrokerSyncRoute
  '/campaign': typeof ShellCampaignRouteWithChildren
  '/campaigns': typeof ShellCampaignsRoute
  '/carrier-reconcile': typeof ShellCarrierReconcileRoute
  '/changelogs': typeof ShellChangelogsRoute
  '/check-rate': typeof ShellCheckRateRoute
  '/comm-files': typeof ShellCommFilesRoute
  '/comm-templates': typeof ShellCommTemplatesRoute
  '/communications': typeof ShellCommunicationsRoute
  '/contact-consents': typeof ShellContactConsentsRoute
  '/conversations': typeof ShellConversationsRoute
  '/credential-groups': typeof ShellCredentialGroupsRoute
  '/credit-cards': typeof ShellCreditCardsRoute
  '/deliverability': typeof ShellDeliverabilityRoute
  '/dispatches': typeof ShellDispatchesRoute
  '/distributions': typeof ShellDistributionsRoute
  '/email-messages': typeof ShellEmailMessagesRoute
  '/geocodes': typeof ShellGeocodesRoute
  '/group-loadboard': typeof ShellGroupLoadboardRoute
  '/group-subscriptions': typeof ShellGroupSubscriptionsRoute
  '/home': typeof ShellHomeRoute
  '/import': typeof ShellImportRoute
  '/inbox': typeof ShellInboxRoute
  '/inboxes': typeof ShellInboxesRoute
  '/insights': typeof ShellInsightsRoute
  '/integrations': typeof ShellIntegrationsRoute
  '/lead-submissions': typeof ShellLeadSubmissionsRoute
  '/leads': typeof ShellLeadsRouteWithChildren
  '/loadboards': typeof ShellLoadboardsRoute
  '/logs': typeof ShellLogsRoute
  '/mail-accounts': typeof ShellMailAccountsRoute
  '/mail-pricing': typeof ShellMailPricingRoute
  '/mail-settings': typeof ShellMailSettingsRoute
  '/mass-call-detections': typeof ShellMassCallDetectionsRoute
  '/mass-jobs': typeof ShellMassJobsRoute
  '/messaging-profiles': typeof ShellMessagingProfilesRoute
  '/models': typeof ShellModelsRoute
  '/notifications': typeof ShellNotificationsRoute
  '/number-events': typeof ShellNumberEventsRoute
  '/number-orders': typeof ShellNumberOrdersRoute
  '/numbers': typeof ShellNumbersRoute
  '/order-feedback': typeof ShellOrderFeedbackRoute
  '/orders': typeof ShellOrdersRouteWithChildren
  '/org-ai': typeof ShellOrgAiRoute
  '/payment-methods': typeof ShellPaymentMethodsRoute
  '/payments': typeof ShellPaymentsRoute
  '/plans': typeof ShellPlansRoute
  '/playground': typeof ShellPlaygroundRoute
  '/porting-orders': typeof ShellPortingOrdersRoute
  '/pricing-usage': typeof ShellPricingUsageRoute
  '/promotions': typeof ShellPromotionsRoute
  '/provider-switches': typeof ShellProviderSwitchesRoute
  '/quiet-hours': typeof ShellQuietHoursRoute
  '/quotes': typeof ShellQuotesRouteWithChildren
  '/security': typeof ShellSecurityRoute
  '/sender-health': typeof ShellSenderHealthRoute
  '/shipment-events': typeof ShellShipmentEventsRoute
  '/shipment-reasons': typeof ShellShipmentReasonsRoute
  '/sip': typeof ShellSipRoute
  '/skills': typeof ShellSkillsRoute
  '/sms-messages': typeof ShellSmsMessagesRoute
  '/spam-controls': typeof ShellSpamControlsRoute
  '/speko-numbers': typeof ShellSpekoNumbersRoute
  '/subscription-invoices': typeof ShellSubscriptionInvoicesRoute
  '/subscriptions': typeof ShellSubscriptionsRoute
  '/tags': typeof ShellTagsRoute
  '/tasks': typeof ShellTasksRoute
  '/texting-automation': typeof ShellTextingAutomationRoute
  '/thecargo-mail': typeof ShellThecargoMailRoute
  '/tip-presets': typeof ShellTipPresetsRoute
  '/tools': typeof ShellToolsRoute
  '/voices': typeof ShellVoicesRoute
  '/voip': typeof ShellVoipRoute
  '/wallet-topups': typeof ShellWalletTopupsRoute
  '/webhook-events': typeof ShellWebhookEventsRoute
  '/login/passkey': typeof LoginPasskeyRoute
  '/login/recovery': typeof LoginRecoveryRoute
  '/ai-rates/$rateId': typeof ShellAiRatesRateIdRoute
  '/announcements/create': typeof ShellAnnouncementsCreateRoute
  '/blog-posts/$postId': typeof ShellBlogPostsPostIdRoute
  '/brokers/$usdot': typeof ShellBrokersUsdotRoute
  '/calls/$callId': typeof ShellCallsCallIdRoute
  '/campaign/$campaignId': typeof ShellCampaignCampaignIdRoute
  '/carriers/$carrierId': typeof ShellCarriersCarrierIdRoute
  '/contract-templates/$templateId': typeof ShellContractTemplatesTemplateIdRoute
  '/customers/$customerId': typeof ShellCustomersCustomerIdRoute
  '/fmcsa-carriers/$usdot': typeof ShellFmcsaCarriersUsdotRoute
  '/leads/$leadId': typeof ShellLeadsLeadIdRouteWithChildren
  '/messaging-prices/$priceId': typeof ShellMessagingPricesPriceIdRoute
  '/orders/$orderId': typeof ShellOrdersOrderIdRouteWithChildren
  '/organizations/$organizationId': typeof ShellOrganizationsOrganizationIdRoute
  '/providers/$providerId': typeof ShellProvidersProviderIdRoute
  '/quotes/$quoteId': typeof ShellQuotesQuoteIdRouteWithChildren
  '/role-templates/$templateId': typeof ShellRoleTemplatesTemplateIdRoute
  '/roles/$roleId': typeof ShellRolesRoleIdRoute
  '/shipments/$shipmentId': typeof ShellShipmentsShipmentIdRoute
  '/teams/$teamId': typeof ShellTeamsTeamIdRoute
  '/users/$userId': typeof ShellUsersUserIdRoute
  '/ai-rates/': typeof ShellAiRatesIndexRoute
  '/announcements/': typeof ShellAnnouncementsIndexRoute
  '/blog-posts/': typeof ShellBlogPostsIndexRoute
  '/brokers/': typeof ShellBrokersIndexRoute
  '/calls/': typeof ShellCallsIndexRoute
  '/campaign/': typeof ShellCampaignIndexRoute
  '/carriers/': typeof ShellCarriersIndexRoute
  '/contract-templates/': typeof ShellContractTemplatesIndexRoute
  '/customers/': typeof ShellCustomersIndexRoute
  '/fmcsa-carriers/': typeof ShellFmcsaCarriersIndexRoute
  '/messaging-prices/': typeof ShellMessagingPricesIndexRoute
  '/organizations/': typeof ShellOrganizationsIndexRoute
  '/providers/': typeof ShellProvidersIndexRoute
  '/role-templates/': typeof ShellRoleTemplatesIndexRoute
  '/roles/': typeof ShellRolesIndexRoute
  '/shipments/': typeof ShellShipmentsIndexRoute
  '/teams/': typeof ShellTeamsIndexRoute
  '/users/': typeof ShellUsersIndexRoute
  '/leads/$leadId/convert': typeof ShellLeadsLeadIdConvertRoute
  '/leads/$leadId/edit': typeof ShellLeadsLeadIdEditRoute
  '/orders/$orderId/dispatch': typeof ShellOrdersOrderIdDispatchRoute
  '/orders/$orderId/edit': typeof ShellOrdersOrderIdEditRoute
  '/organizations/$organizationId/edit': typeof ShellOrganizationsOrganizationIdEditRoute
  '/quotes/$quoteId/convert': typeof ShellQuotesQuoteIdConvertRoute
  '/quotes/$quoteId/edit': typeof ShellQuotesQuoteIdEditRoute
  '/shipments/$shipmentId/edit': typeof ShellShipmentsShipmentIdEditRoute
  '/leads/$leadId/': typeof ShellLeadsLeadIdIndexRoute
  '/orders/$orderId/': typeof ShellOrdersOrderIdIndexRoute
  '/quotes/$quoteId/': typeof ShellQuotesQuoteIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/admins': typeof ShellAdminsRoute
  '/agents': typeof ShellAgentsRoute
  '/ai-costs': typeof ShellAiCostsRoute
  '/announcement-bar': typeof ShellAnnouncementBarRoute
  '/audit': typeof ShellAuditRoute
  '/automations': typeof ShellAutomationsRoute
  '/billing-rules': typeof ShellBillingRulesRoute
  '/brands': typeof ShellBrandsRoute
  '/broker-changes': typeof ShellBrokerChangesRoute
  '/broker-overview': typeof ShellBrokerOverviewRoute
  '/broker-sync': typeof ShellBrokerSyncRoute
  '/campaigns': typeof ShellCampaignsRoute
  '/carrier-reconcile': typeof ShellCarrierReconcileRoute
  '/changelogs': typeof ShellChangelogsRoute
  '/check-rate': typeof ShellCheckRateRoute
  '/comm-files': typeof ShellCommFilesRoute
  '/comm-templates': typeof ShellCommTemplatesRoute
  '/communications': typeof ShellCommunicationsRoute
  '/contact-consents': typeof ShellContactConsentsRoute
  '/conversations': typeof ShellConversationsRoute
  '/credential-groups': typeof ShellCredentialGroupsRoute
  '/credit-cards': typeof ShellCreditCardsRoute
  '/deliverability': typeof ShellDeliverabilityRoute
  '/dispatches': typeof ShellDispatchesRoute
  '/distributions': typeof ShellDistributionsRoute
  '/email-messages': typeof ShellEmailMessagesRoute
  '/geocodes': typeof ShellGeocodesRoute
  '/group-loadboard': typeof ShellGroupLoadboardRoute
  '/group-subscriptions': typeof ShellGroupSubscriptionsRoute
  '/home': typeof ShellHomeRoute
  '/import': typeof ShellImportRoute
  '/inbox': typeof ShellInboxRoute
  '/inboxes': typeof ShellInboxesRoute
  '/insights': typeof ShellInsightsRoute
  '/integrations': typeof ShellIntegrationsRoute
  '/lead-submissions': typeof ShellLeadSubmissionsRoute
  '/leads': typeof ShellLeadsRouteWithChildren
  '/loadboards': typeof ShellLoadboardsRoute
  '/logs': typeof ShellLogsRoute
  '/mail-accounts': typeof ShellMailAccountsRoute
  '/mail-pricing': typeof ShellMailPricingRoute
  '/mail-settings': typeof ShellMailSettingsRoute
  '/mass-call-detections': typeof ShellMassCallDetectionsRoute
  '/mass-jobs': typeof ShellMassJobsRoute
  '/messaging-profiles': typeof ShellMessagingProfilesRoute
  '/models': typeof ShellModelsRoute
  '/notifications': typeof ShellNotificationsRoute
  '/number-events': typeof ShellNumberEventsRoute
  '/number-orders': typeof ShellNumberOrdersRoute
  '/numbers': typeof ShellNumbersRoute
  '/order-feedback': typeof ShellOrderFeedbackRoute
  '/orders': typeof ShellOrdersRouteWithChildren
  '/org-ai': typeof ShellOrgAiRoute
  '/payment-methods': typeof ShellPaymentMethodsRoute
  '/payments': typeof ShellPaymentsRoute
  '/plans': typeof ShellPlansRoute
  '/playground': typeof ShellPlaygroundRoute
  '/porting-orders': typeof ShellPortingOrdersRoute
  '/pricing-usage': typeof ShellPricingUsageRoute
  '/promotions': typeof ShellPromotionsRoute
  '/provider-switches': typeof ShellProviderSwitchesRoute
  '/quiet-hours': typeof ShellQuietHoursRoute
  '/quotes': typeof ShellQuotesRouteWithChildren
  '/security': typeof ShellSecurityRoute
  '/sender-health': typeof ShellSenderHealthRoute
  '/shipment-events': typeof ShellShipmentEventsRoute
  '/shipment-reasons': typeof ShellShipmentReasonsRoute
  '/sip': typeof ShellSipRoute
  '/skills': typeof ShellSkillsRoute
  '/sms-messages': typeof ShellSmsMessagesRoute
  '/spam-controls': typeof ShellSpamControlsRoute
  '/speko-numbers': typeof ShellSpekoNumbersRoute
  '/subscription-invoices': typeof ShellSubscriptionInvoicesRoute
  '/subscriptions': typeof ShellSubscriptionsRoute
  '/tags': typeof ShellTagsRoute
  '/tasks': typeof ShellTasksRoute
  '/texting-automation': typeof ShellTextingAutomationRoute
  '/thecargo-mail': typeof ShellThecargoMailRoute
  '/tip-presets': typeof ShellTipPresetsRoute
  '/tools': typeof ShellToolsRoute
  '/voices': typeof ShellVoicesRoute
  '/voip': typeof ShellVoipRoute
  '/wallet-topups': typeof ShellWalletTopupsRoute
  '/webhook-events': typeof ShellWebhookEventsRoute
  '/login/passkey': typeof LoginPasskeyRoute
  '/login/recovery': typeof LoginRecoveryRoute
  '/': typeof ShellIndexRoute
  '/ai-rates/$rateId': typeof ShellAiRatesRateIdRoute
  '/announcements/create': typeof ShellAnnouncementsCreateRoute
  '/blog-posts/$postId': typeof ShellBlogPostsPostIdRoute
  '/brokers/$usdot': typeof ShellBrokersUsdotRoute
  '/calls/$callId': typeof ShellCallsCallIdRoute
  '/campaign/$campaignId': typeof ShellCampaignCampaignIdRoute
  '/carriers/$carrierId': typeof ShellCarriersCarrierIdRoute
  '/contract-templates/$templateId': typeof ShellContractTemplatesTemplateIdRoute
  '/customers/$customerId': typeof ShellCustomersCustomerIdRoute
  '/fmcsa-carriers/$usdot': typeof ShellFmcsaCarriersUsdotRoute
  '/messaging-prices/$priceId': typeof ShellMessagingPricesPriceIdRoute
  '/organizations/$organizationId': typeof ShellOrganizationsOrganizationIdRoute
  '/providers/$providerId': typeof ShellProvidersProviderIdRoute
  '/role-templates/$templateId': typeof ShellRoleTemplatesTemplateIdRoute
  '/roles/$roleId': typeof ShellRolesRoleIdRoute
  '/shipments/$shipmentId': typeof ShellShipmentsShipmentIdRoute
  '/teams/$teamId': typeof ShellTeamsTeamIdRoute
  '/users/$userId': typeof ShellUsersUserIdRoute
  '/ai-rates': typeof ShellAiRatesIndexRoute
  '/announcements': typeof ShellAnnouncementsIndexRoute
  '/blog-posts': typeof ShellBlogPostsIndexRoute
  '/brokers': typeof ShellBrokersIndexRoute
  '/calls': typeof ShellCallsIndexRoute
  '/campaign': typeof ShellCampaignIndexRoute
  '/carriers': typeof ShellCarriersIndexRoute
  '/contract-templates': typeof ShellContractTemplatesIndexRoute
  '/customers': typeof ShellCustomersIndexRoute
  '/fmcsa-carriers': typeof ShellFmcsaCarriersIndexRoute
  '/messaging-prices': typeof ShellMessagingPricesIndexRoute
  '/organizations': typeof ShellOrganizationsIndexRoute
  '/providers': typeof ShellProvidersIndexRoute
  '/role-templates': typeof ShellRoleTemplatesIndexRoute
  '/roles': typeof ShellRolesIndexRoute
  '/shipments': typeof ShellShipmentsIndexRoute
  '/teams': typeof ShellTeamsIndexRoute
  '/users': typeof ShellUsersIndexRoute
  '/leads/$leadId/convert': typeof ShellLeadsLeadIdConvertRoute
  '/leads/$leadId/edit': typeof ShellLeadsLeadIdEditRoute
  '/orders/$orderId/dispatch': typeof ShellOrdersOrderIdDispatchRoute
  '/orders/$orderId/edit': typeof ShellOrdersOrderIdEditRoute
  '/organizations/$organizationId/edit': typeof ShellOrganizationsOrganizationIdEditRoute
  '/quotes/$quoteId/convert': typeof ShellQuotesQuoteIdConvertRoute
  '/quotes/$quoteId/edit': typeof ShellQuotesQuoteIdEditRoute
  '/shipments/$shipmentId/edit': typeof ShellShipmentsShipmentIdEditRoute
  '/leads/$leadId': typeof ShellLeadsLeadIdIndexRoute
  '/orders/$orderId': typeof ShellOrdersOrderIdIndexRoute
  '/quotes/$quoteId': typeof ShellQuotesQuoteIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_shell': typeof ShellRouteWithChildren
  '/login': typeof LoginRoute
  '/_shell/admins': typeof ShellAdminsRoute
  '/_shell/agents': typeof ShellAgentsRoute
  '/_shell/ai-costs': typeof ShellAiCostsRoute
  '/_shell/announcement-bar': typeof ShellAnnouncementBarRoute
  '/_shell/audit': typeof ShellAuditRoute
  '/_shell/automations': typeof ShellAutomationsRoute
  '/_shell/billing-rules': typeof ShellBillingRulesRoute
  '/_shell/brands': typeof ShellBrandsRoute
  '/_shell/broker-changes': typeof ShellBrokerChangesRoute
  '/_shell/broker-overview': typeof ShellBrokerOverviewRoute
  '/_shell/broker-sync': typeof ShellBrokerSyncRoute
  '/_shell/campaign': typeof ShellCampaignRouteWithChildren
  '/_shell/campaigns': typeof ShellCampaignsRoute
  '/_shell/carrier-reconcile': typeof ShellCarrierReconcileRoute
  '/_shell/changelogs': typeof ShellChangelogsRoute
  '/_shell/check-rate': typeof ShellCheckRateRoute
  '/_shell/comm-files': typeof ShellCommFilesRoute
  '/_shell/comm-templates': typeof ShellCommTemplatesRoute
  '/_shell/communications': typeof ShellCommunicationsRoute
  '/_shell/contact-consents': typeof ShellContactConsentsRoute
  '/_shell/conversations': typeof ShellConversationsRoute
  '/_shell/credential-groups': typeof ShellCredentialGroupsRoute
  '/_shell/credit-cards': typeof ShellCreditCardsRoute
  '/_shell/deliverability': typeof ShellDeliverabilityRoute
  '/_shell/dispatches': typeof ShellDispatchesRoute
  '/_shell/distributions': typeof ShellDistributionsRoute
  '/_shell/email-messages': typeof ShellEmailMessagesRoute
  '/_shell/geocodes': typeof ShellGeocodesRoute
  '/_shell/group-loadboard': typeof ShellGroupLoadboardRoute
  '/_shell/group-subscriptions': typeof ShellGroupSubscriptionsRoute
  '/_shell/home': typeof ShellHomeRoute
  '/_shell/import': typeof ShellImportRoute
  '/_shell/inbox': typeof ShellInboxRoute
  '/_shell/inboxes': typeof ShellInboxesRoute
  '/_shell/insights': typeof ShellInsightsRoute
  '/_shell/integrations': typeof ShellIntegrationsRoute
  '/_shell/lead-submissions': typeof ShellLeadSubmissionsRoute
  '/_shell/leads': typeof ShellLeadsRouteWithChildren
  '/_shell/loadboards': typeof ShellLoadboardsRoute
  '/_shell/logs': typeof ShellLogsRoute
  '/_shell/mail-accounts': typeof ShellMailAccountsRoute
  '/_shell/mail-pricing': typeof ShellMailPricingRoute
  '/_shell/mail-settings': typeof ShellMailSettingsRoute
  '/_shell/mass-call-detections': typeof ShellMassCallDetectionsRoute
  '/_shell/mass-jobs': typeof ShellMassJobsRoute
  '/_shell/messaging-profiles': typeof ShellMessagingProfilesRoute
  '/_shell/models': typeof ShellModelsRoute
  '/_shell/notifications': typeof ShellNotificationsRoute
  '/_shell/number-events': typeof ShellNumberEventsRoute
  '/_shell/number-orders': typeof ShellNumberOrdersRoute
  '/_shell/numbers': typeof ShellNumbersRoute
  '/_shell/order-feedback': typeof ShellOrderFeedbackRoute
  '/_shell/orders': typeof ShellOrdersRouteWithChildren
  '/_shell/org-ai': typeof ShellOrgAiRoute
  '/_shell/payment-methods': typeof ShellPaymentMethodsRoute
  '/_shell/payments': typeof ShellPaymentsRoute
  '/_shell/plans': typeof ShellPlansRoute
  '/_shell/playground': typeof ShellPlaygroundRoute
  '/_shell/porting-orders': typeof ShellPortingOrdersRoute
  '/_shell/pricing-usage': typeof ShellPricingUsageRoute
  '/_shell/promotions': typeof ShellPromotionsRoute
  '/_shell/provider-switches': typeof ShellProviderSwitchesRoute
  '/_shell/quiet-hours': typeof ShellQuietHoursRoute
  '/_shell/quotes': typeof ShellQuotesRouteWithChildren
  '/_shell/security': typeof ShellSecurityRoute
  '/_shell/sender-health': typeof ShellSenderHealthRoute
  '/_shell/shipment-events': typeof ShellShipmentEventsRoute
  '/_shell/shipment-reasons': typeof ShellShipmentReasonsRoute
  '/_shell/sip': typeof ShellSipRoute
  '/_shell/skills': typeof ShellSkillsRoute
  '/_shell/sms-messages': typeof ShellSmsMessagesRoute
  '/_shell/spam-controls': typeof ShellSpamControlsRoute
  '/_shell/speko-numbers': typeof ShellSpekoNumbersRoute
  '/_shell/subscription-invoices': typeof ShellSubscriptionInvoicesRoute
  '/_shell/subscriptions': typeof ShellSubscriptionsRoute
  '/_shell/tags': typeof ShellTagsRoute
  '/_shell/tasks': typeof ShellTasksRoute
  '/_shell/texting-automation': typeof ShellTextingAutomationRoute
  '/_shell/thecargo-mail': typeof ShellThecargoMailRoute
  '/_shell/tip-presets': typeof ShellTipPresetsRoute
  '/_shell/tools': typeof ShellToolsRoute
  '/_shell/voices': typeof ShellVoicesRoute
  '/_shell/voip': typeof ShellVoipRoute
  '/_shell/wallet-topups': typeof ShellWalletTopupsRoute
  '/_shell/webhook-events': typeof ShellWebhookEventsRoute
  '/login_/passkey': typeof LoginPasskeyRoute
  '/login_/recovery': typeof LoginRecoveryRoute
  '/_shell/': typeof ShellIndexRoute
  '/_shell/ai-rates/$rateId': typeof ShellAiRatesRateIdRoute
  '/_shell/announcements/create': typeof ShellAnnouncementsCreateRoute
  '/_shell/blog-posts/$postId': typeof ShellBlogPostsPostIdRoute
  '/_shell/brokers/$usdot': typeof ShellBrokersUsdotRoute
  '/_shell/calls/$callId': typeof ShellCallsCallIdRoute
  '/_shell/campaign/$campaignId': typeof ShellCampaignCampaignIdRoute
  '/_shell/carriers/$carrierId': typeof ShellCarriersCarrierIdRoute
  '/_shell/contract-templates/$templateId': typeof ShellContractTemplatesTemplateIdRoute
  '/_shell/customers/$customerId': typeof ShellCustomersCustomerIdRoute
  '/_shell/fmcsa-carriers/$usdot': typeof ShellFmcsaCarriersUsdotRoute
  '/_shell/leads/$leadId': typeof ShellLeadsLeadIdRouteWithChildren
  '/_shell/messaging-prices/$priceId': typeof ShellMessagingPricesPriceIdRoute
  '/_shell/orders/$orderId': typeof ShellOrdersOrderIdRouteWithChildren
  '/_shell/organizations/$organizationId': typeof ShellOrganizationsOrganizationIdRoute
  '/_shell/providers/$providerId': typeof ShellProvidersProviderIdRoute
  '/_shell/quotes/$quoteId': typeof ShellQuotesQuoteIdRouteWithChildren
  '/_shell/role-templates/$templateId': typeof ShellRoleTemplatesTemplateIdRoute
  '/_shell/roles/$roleId': typeof ShellRolesRoleIdRoute
  '/_shell/shipments/$shipmentId': typeof ShellShipmentsShipmentIdRoute
  '/_shell/teams/$teamId': typeof ShellTeamsTeamIdRoute
  '/_shell/users/$userId': typeof ShellUsersUserIdRoute
  '/_shell/ai-rates/': typeof ShellAiRatesIndexRoute
  '/_shell/announcements/': typeof ShellAnnouncementsIndexRoute
  '/_shell/blog-posts/': typeof ShellBlogPostsIndexRoute
  '/_shell/brokers/': typeof ShellBrokersIndexRoute
  '/_shell/calls/': typeof ShellCallsIndexRoute
  '/_shell/campaign/': typeof ShellCampaignIndexRoute
  '/_shell/carriers/': typeof ShellCarriersIndexRoute
  '/_shell/contract-templates/': typeof ShellContractTemplatesIndexRoute
  '/_shell/customers/': typeof ShellCustomersIndexRoute
  '/_shell/fmcsa-carriers/': typeof ShellFmcsaCarriersIndexRoute
  '/_shell/messaging-prices/': typeof ShellMessagingPricesIndexRoute
  '/_shell/organizations/': typeof ShellOrganizationsIndexRoute
  '/_shell/providers/': typeof ShellProvidersIndexRoute
  '/_shell/role-templates/': typeof ShellRoleTemplatesIndexRoute
  '/_shell/roles/': typeof ShellRolesIndexRoute
  '/_shell/shipments/': typeof ShellShipmentsIndexRoute
  '/_shell/teams/': typeof ShellTeamsIndexRoute
  '/_shell/users/': typeof ShellUsersIndexRoute
  '/_shell/leads/$leadId/convert': typeof ShellLeadsLeadIdConvertRoute
  '/_shell/leads/$leadId/edit': typeof ShellLeadsLeadIdEditRoute
  '/_shell/orders/$orderId/dispatch': typeof ShellOrdersOrderIdDispatchRoute
  '/_shell/orders/$orderId/edit': typeof ShellOrdersOrderIdEditRoute
  '/_shell/organizations/$organizationId_/edit': typeof ShellOrganizationsOrganizationIdEditRoute
  '/_shell/quotes/$quoteId/convert': typeof ShellQuotesQuoteIdConvertRoute
  '/_shell/quotes/$quoteId/edit': typeof ShellQuotesQuoteIdEditRoute
  '/_shell/shipments_/$shipmentId/edit': typeof ShellShipmentsShipmentIdEditRoute
  '/_shell/leads/$leadId/': typeof ShellLeadsLeadIdIndexRoute
  '/_shell/orders/$orderId/': typeof ShellOrdersOrderIdIndexRoute
  '/_shell/quotes/$quoteId/': typeof ShellQuotesQuoteIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admins'
    | '/agents'
    | '/ai-costs'
    | '/announcement-bar'
    | '/audit'
    | '/automations'
    | '/billing-rules'
    | '/brands'
    | '/broker-changes'
    | '/broker-overview'
    | '/broker-sync'
    | '/campaign'
    | '/campaigns'
    | '/carrier-reconcile'
    | '/changelogs'
    | '/check-rate'
    | '/comm-files'
    | '/comm-templates'
    | '/communications'
    | '/contact-consents'
    | '/conversations'
    | '/credential-groups'
    | '/credit-cards'
    | '/deliverability'
    | '/dispatches'
    | '/distributions'
    | '/email-messages'
    | '/geocodes'
    | '/group-loadboard'
    | '/group-subscriptions'
    | '/home'
    | '/import'
    | '/inbox'
    | '/inboxes'
    | '/insights'
    | '/integrations'
    | '/lead-submissions'
    | '/leads'
    | '/loadboards'
    | '/logs'
    | '/mail-accounts'
    | '/mail-pricing'
    | '/mail-settings'
    | '/mass-call-detections'
    | '/mass-jobs'
    | '/messaging-profiles'
    | '/models'
    | '/notifications'
    | '/number-events'
    | '/number-orders'
    | '/numbers'
    | '/order-feedback'
    | '/orders'
    | '/org-ai'
    | '/payment-methods'
    | '/payments'
    | '/plans'
    | '/playground'
    | '/porting-orders'
    | '/pricing-usage'
    | '/promotions'
    | '/provider-switches'
    | '/quiet-hours'
    | '/quotes'
    | '/security'
    | '/sender-health'
    | '/shipment-events'
    | '/shipment-reasons'
    | '/sip'
    | '/skills'
    | '/sms-messages'
    | '/spam-controls'
    | '/speko-numbers'
    | '/subscription-invoices'
    | '/subscriptions'
    | '/tags'
    | '/tasks'
    | '/texting-automation'
    | '/thecargo-mail'
    | '/tip-presets'
    | '/tools'
    | '/voices'
    | '/voip'
    | '/wallet-topups'
    | '/webhook-events'
    | '/login/passkey'
    | '/login/recovery'
    | '/ai-rates/$rateId'
    | '/announcements/create'
    | '/blog-posts/$postId'
    | '/brokers/$usdot'
    | '/calls/$callId'
    | '/campaign/$campaignId'
    | '/carriers/$carrierId'
    | '/contract-templates/$templateId'
    | '/customers/$customerId'
    | '/fmcsa-carriers/$usdot'
    | '/leads/$leadId'
    | '/messaging-prices/$priceId'
    | '/orders/$orderId'
    | '/organizations/$organizationId'
    | '/providers/$providerId'
    | '/quotes/$quoteId'
    | '/role-templates/$templateId'
    | '/roles/$roleId'
    | '/shipments/$shipmentId'
    | '/teams/$teamId'
    | '/users/$userId'
    | '/ai-rates/'
    | '/announcements/'
    | '/blog-posts/'
    | '/brokers/'
    | '/calls/'
    | '/campaign/'
    | '/carriers/'
    | '/contract-templates/'
    | '/customers/'
    | '/fmcsa-carriers/'
    | '/messaging-prices/'
    | '/organizations/'
    | '/providers/'
    | '/role-templates/'
    | '/roles/'
    | '/shipments/'
    | '/teams/'
    | '/users/'
    | '/leads/$leadId/convert'
    | '/leads/$leadId/edit'
    | '/orders/$orderId/dispatch'
    | '/orders/$orderId/edit'
    | '/organizations/$organizationId/edit'
    | '/quotes/$quoteId/convert'
    | '/quotes/$quoteId/edit'
    | '/shipments/$shipmentId/edit'
    | '/leads/$leadId/'
    | '/orders/$orderId/'
    | '/quotes/$quoteId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/admins'
    | '/agents'
    | '/ai-costs'
    | '/announcement-bar'
    | '/audit'
    | '/automations'
    | '/billing-rules'
    | '/brands'
    | '/broker-changes'
    | '/broker-overview'
    | '/broker-sync'
    | '/campaigns'
    | '/carrier-reconcile'
    | '/changelogs'
    | '/check-rate'
    | '/comm-files'
    | '/comm-templates'
    | '/communications'
    | '/contact-consents'
    | '/conversations'
    | '/credential-groups'
    | '/credit-cards'
    | '/deliverability'
    | '/dispatches'
    | '/distributions'
    | '/email-messages'
    | '/geocodes'
    | '/group-loadboard'
    | '/group-subscriptions'
    | '/home'
    | '/import'
    | '/inbox'
    | '/inboxes'
    | '/insights'
    | '/integrations'
    | '/lead-submissions'
    | '/leads'
    | '/loadboards'
    | '/logs'
    | '/mail-accounts'
    | '/mail-pricing'
    | '/mail-settings'
    | '/mass-call-detections'
    | '/mass-jobs'
    | '/messaging-profiles'
    | '/models'
    | '/notifications'
    | '/number-events'
    | '/number-orders'
    | '/numbers'
    | '/order-feedback'
    | '/orders'
    | '/org-ai'
    | '/payment-methods'
    | '/payments'
    | '/plans'
    | '/playground'
    | '/porting-orders'
    | '/pricing-usage'
    | '/promotions'
    | '/provider-switches'
    | '/quiet-hours'
    | '/quotes'
    | '/security'
    | '/sender-health'
    | '/shipment-events'
    | '/shipment-reasons'
    | '/sip'
    | '/skills'
    | '/sms-messages'
    | '/spam-controls'
    | '/speko-numbers'
    | '/subscription-invoices'
    | '/subscriptions'
    | '/tags'
    | '/tasks'
    | '/texting-automation'
    | '/thecargo-mail'
    | '/tip-presets'
    | '/tools'
    | '/voices'
    | '/voip'
    | '/wallet-topups'
    | '/webhook-events'
    | '/login/passkey'
    | '/login/recovery'
    | '/'
    | '/ai-rates/$rateId'
    | '/announcements/create'
    | '/blog-posts/$postId'
    | '/brokers/$usdot'
    | '/calls/$callId'
    | '/campaign/$campaignId'
    | '/carriers/$carrierId'
    | '/contract-templates/$templateId'
    | '/customers/$customerId'
    | '/fmcsa-carriers/$usdot'
    | '/messaging-prices/$priceId'
    | '/organizations/$organizationId'
    | '/providers/$providerId'
    | '/role-templates/$templateId'
    | '/roles/$roleId'
    | '/shipments/$shipmentId'
    | '/teams/$teamId'
    | '/users/$userId'
    | '/ai-rates'
    | '/announcements'
    | '/blog-posts'
    | '/brokers'
    | '/calls'
    | '/campaign'
    | '/carriers'
    | '/contract-templates'
    | '/customers'
    | '/fmcsa-carriers'
    | '/messaging-prices'
    | '/organizations'
    | '/providers'
    | '/role-templates'
    | '/roles'
    | '/shipments'
    | '/teams'
    | '/users'
    | '/leads/$leadId/convert'
    | '/leads/$leadId/edit'
    | '/orders/$orderId/dispatch'
    | '/orders/$orderId/edit'
    | '/organizations/$organizationId/edit'
    | '/quotes/$quoteId/convert'
    | '/quotes/$quoteId/edit'
    | '/shipments/$shipmentId/edit'
    | '/leads/$leadId'
    | '/orders/$orderId'
    | '/quotes/$quoteId'
  id:
    | '__root__'
    | '/_shell'
    | '/login'
    | '/_shell/admins'
    | '/_shell/agents'
    | '/_shell/ai-costs'
    | '/_shell/announcement-bar'
    | '/_shell/audit'
    | '/_shell/automations'
    | '/_shell/billing-rules'
    | '/_shell/brands'
    | '/_shell/broker-changes'
    | '/_shell/broker-overview'
    | '/_shell/broker-sync'
    | '/_shell/campaign'
    | '/_shell/campaigns'
    | '/_shell/carrier-reconcile'
    | '/_shell/changelogs'
    | '/_shell/check-rate'
    | '/_shell/comm-files'
    | '/_shell/comm-templates'
    | '/_shell/communications'
    | '/_shell/contact-consents'
    | '/_shell/conversations'
    | '/_shell/credential-groups'
    | '/_shell/credit-cards'
    | '/_shell/deliverability'
    | '/_shell/dispatches'
    | '/_shell/distributions'
    | '/_shell/email-messages'
    | '/_shell/geocodes'
    | '/_shell/group-loadboard'
    | '/_shell/group-subscriptions'
    | '/_shell/home'
    | '/_shell/import'
    | '/_shell/inbox'
    | '/_shell/inboxes'
    | '/_shell/insights'
    | '/_shell/integrations'
    | '/_shell/lead-submissions'
    | '/_shell/leads'
    | '/_shell/loadboards'
    | '/_shell/logs'
    | '/_shell/mail-accounts'
    | '/_shell/mail-pricing'
    | '/_shell/mail-settings'
    | '/_shell/mass-call-detections'
    | '/_shell/mass-jobs'
    | '/_shell/messaging-profiles'
    | '/_shell/models'
    | '/_shell/notifications'
    | '/_shell/number-events'
    | '/_shell/number-orders'
    | '/_shell/numbers'
    | '/_shell/order-feedback'
    | '/_shell/orders'
    | '/_shell/org-ai'
    | '/_shell/payment-methods'
    | '/_shell/payments'
    | '/_shell/plans'
    | '/_shell/playground'
    | '/_shell/porting-orders'
    | '/_shell/pricing-usage'
    | '/_shell/promotions'
    | '/_shell/provider-switches'
    | '/_shell/quiet-hours'
    | '/_shell/quotes'
    | '/_shell/security'
    | '/_shell/sender-health'
    | '/_shell/shipment-events'
    | '/_shell/shipment-reasons'
    | '/_shell/sip'
    | '/_shell/skills'
    | '/_shell/sms-messages'
    | '/_shell/spam-controls'
    | '/_shell/speko-numbers'
    | '/_shell/subscription-invoices'
    | '/_shell/subscriptions'
    | '/_shell/tags'
    | '/_shell/tasks'
    | '/_shell/texting-automation'
    | '/_shell/thecargo-mail'
    | '/_shell/tip-presets'
    | '/_shell/tools'
    | '/_shell/voices'
    | '/_shell/voip'
    | '/_shell/wallet-topups'
    | '/_shell/webhook-events'
    | '/login_/passkey'
    | '/login_/recovery'
    | '/_shell/'
    | '/_shell/ai-rates/$rateId'
    | '/_shell/announcements/create'
    | '/_shell/blog-posts/$postId'
    | '/_shell/brokers/$usdot'
    | '/_shell/calls/$callId'
    | '/_shell/campaign/$campaignId'
    | '/_shell/carriers/$carrierId'
    | '/_shell/contract-templates/$templateId'
    | '/_shell/customers/$customerId'
    | '/_shell/fmcsa-carriers/$usdot'
    | '/_shell/leads/$leadId'
    | '/_shell/messaging-prices/$priceId'
    | '/_shell/orders/$orderId'
    | '/_shell/organizations/$organizationId'
    | '/_shell/providers/$providerId'
    | '/_shell/quotes/$quoteId'
    | '/_shell/role-templates/$templateId'
    | '/_shell/roles/$roleId'
    | '/_shell/shipments/$shipmentId'
    | '/_shell/teams/$teamId'
    | '/_shell/users/$userId'
    | '/_shell/ai-rates/'
    | '/_shell/announcements/'
    | '/_shell/blog-posts/'
    | '/_shell/brokers/'
    | '/_shell/calls/'
    | '/_shell/campaign/'
    | '/_shell/carriers/'
    | '/_shell/contract-templates/'
    | '/_shell/customers/'
    | '/_shell/fmcsa-carriers/'
    | '/_shell/messaging-prices/'
    | '/_shell/organizations/'
    | '/_shell/providers/'
    | '/_shell/role-templates/'
    | '/_shell/roles/'
    | '/_shell/shipments/'
    | '/_shell/teams/'
    | '/_shell/users/'
    | '/_shell/leads/$leadId/convert'
    | '/_shell/leads/$leadId/edit'
    | '/_shell/orders/$orderId/dispatch'
    | '/_shell/orders/$orderId/edit'
    | '/_shell/organizations/$organizationId_/edit'
    | '/_shell/quotes/$quoteId/convert'
    | '/_shell/quotes/$quoteId/edit'
    | '/_shell/shipments_/$shipmentId/edit'
    | '/_shell/leads/$leadId/'
    | '/_shell/orders/$orderId/'
    | '/_shell/quotes/$quoteId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ShellRoute: typeof ShellRouteWithChildren
  LoginRoute: typeof LoginRoute
  LoginPasskeyRoute: typeof LoginPasskeyRoute
  LoginRecoveryRoute: typeof LoginRecoveryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/': {
      id: '/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShellIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/admins': {
      id: '/_shell/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof ShellAdminsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/agents': {
      id: '/_shell/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof ShellAgentsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/ai-costs': {
      id: '/_shell/ai-costs'
      path: '/ai-costs'
      fullPath: '/ai-costs'
      preLoaderRoute: typeof ShellAiCostsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/announcement-bar': {
      id: '/_shell/announcement-bar'
      path: '/announcement-bar'
      fullPath: '/announcement-bar'
      preLoaderRoute: typeof ShellAnnouncementBarRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/audit': {
      id: '/_shell/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof ShellAuditRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/automations': {
      id: '/_shell/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof ShellAutomationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/billing-rules': {
      id: '/_shell/billing-rules'
      path: '/billing-rules'
      fullPath: '/billing-rules'
      preLoaderRoute: typeof ShellBillingRulesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/brands': {
      id: '/_shell/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof ShellBrandsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/broker-changes': {
      id: '/_shell/broker-changes'
      path: '/broker-changes'
      fullPath: '/broker-changes'
      preLoaderRoute: typeof ShellBrokerChangesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/broker-overview': {
      id: '/_shell/broker-overview'
      path: '/broker-overview'
      fullPath: '/broker-overview'
      preLoaderRoute: typeof ShellBrokerOverviewRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/broker-sync': {
      id: '/_shell/broker-sync'
      path: '/broker-sync'
      fullPath: '/broker-sync'
      preLoaderRoute: typeof ShellBrokerSyncRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/campaign': {
      id: '/_shell/campaign'
      path: '/campaign'
      fullPath: '/campaign'
      preLoaderRoute: typeof ShellCampaignRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/campaigns': {
      id: '/_shell/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof ShellCampaignsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/carrier-reconcile': {
      id: '/_shell/carrier-reconcile'
      path: '/carrier-reconcile'
      fullPath: '/carrier-reconcile'
      preLoaderRoute: typeof ShellCarrierReconcileRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/changelogs': {
      id: '/_shell/changelogs'
      path: '/changelogs'
      fullPath: '/changelogs'
      preLoaderRoute: typeof ShellChangelogsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/check-rate': {
      id: '/_shell/check-rate'
      path: '/check-rate'
      fullPath: '/check-rate'
      preLoaderRoute: typeof ShellCheckRateRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/comm-files': {
      id: '/_shell/comm-files'
      path: '/comm-files'
      fullPath: '/comm-files'
      preLoaderRoute: typeof ShellCommFilesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/comm-templates': {
      id: '/_shell/comm-templates'
      path: '/comm-templates'
      fullPath: '/comm-templates'
      preLoaderRoute: typeof ShellCommTemplatesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/communications': {
      id: '/_shell/communications'
      path: '/communications'
      fullPath: '/communications'
      preLoaderRoute: typeof ShellCommunicationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/contact-consents': {
      id: '/_shell/contact-consents'
      path: '/contact-consents'
      fullPath: '/contact-consents'
      preLoaderRoute: typeof ShellContactConsentsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/conversations': {
      id: '/_shell/conversations'
      path: '/conversations'
      fullPath: '/conversations'
      preLoaderRoute: typeof ShellConversationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/credential-groups': {
      id: '/_shell/credential-groups'
      path: '/credential-groups'
      fullPath: '/credential-groups'
      preLoaderRoute: typeof ShellCredentialGroupsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/credit-cards': {
      id: '/_shell/credit-cards'
      path: '/credit-cards'
      fullPath: '/credit-cards'
      preLoaderRoute: typeof ShellCreditCardsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/deliverability': {
      id: '/_shell/deliverability'
      path: '/deliverability'
      fullPath: '/deliverability'
      preLoaderRoute: typeof ShellDeliverabilityRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/dispatches': {
      id: '/_shell/dispatches'
      path: '/dispatches'
      fullPath: '/dispatches'
      preLoaderRoute: typeof ShellDispatchesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/distributions': {
      id: '/_shell/distributions'
      path: '/distributions'
      fullPath: '/distributions'
      preLoaderRoute: typeof ShellDistributionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/email-messages': {
      id: '/_shell/email-messages'
      path: '/email-messages'
      fullPath: '/email-messages'
      preLoaderRoute: typeof ShellEmailMessagesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/geocodes': {
      id: '/_shell/geocodes'
      path: '/geocodes'
      fullPath: '/geocodes'
      preLoaderRoute: typeof ShellGeocodesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/group-loadboard': {
      id: '/_shell/group-loadboard'
      path: '/group-loadboard'
      fullPath: '/group-loadboard'
      preLoaderRoute: typeof ShellGroupLoadboardRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/group-subscriptions': {
      id: '/_shell/group-subscriptions'
      path: '/group-subscriptions'
      fullPath: '/group-subscriptions'
      preLoaderRoute: typeof ShellGroupSubscriptionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/home': {
      id: '/_shell/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof ShellHomeRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/import': {
      id: '/_shell/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ShellImportRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/inbox': {
      id: '/_shell/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof ShellInboxRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/inboxes': {
      id: '/_shell/inboxes'
      path: '/inboxes'
      fullPath: '/inboxes'
      preLoaderRoute: typeof ShellInboxesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/insights': {
      id: '/_shell/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof ShellInsightsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/integrations': {
      id: '/_shell/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof ShellIntegrationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/lead-submissions': {
      id: '/_shell/lead-submissions'
      path: '/lead-submissions'
      fullPath: '/lead-submissions'
      preLoaderRoute: typeof ShellLeadSubmissionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/leads': {
      id: '/_shell/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof ShellLeadsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/loadboards': {
      id: '/_shell/loadboards'
      path: '/loadboards'
      fullPath: '/loadboards'
      preLoaderRoute: typeof ShellLoadboardsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/logs': {
      id: '/_shell/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof ShellLogsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/mail-accounts': {
      id: '/_shell/mail-accounts'
      path: '/mail-accounts'
      fullPath: '/mail-accounts'
      preLoaderRoute: typeof ShellMailAccountsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/mail-pricing': {
      id: '/_shell/mail-pricing'
      path: '/mail-pricing'
      fullPath: '/mail-pricing'
      preLoaderRoute: typeof ShellMailPricingRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/mail-settings': {
      id: '/_shell/mail-settings'
      path: '/mail-settings'
      fullPath: '/mail-settings'
      preLoaderRoute: typeof ShellMailSettingsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/mass-call-detections': {
      id: '/_shell/mass-call-detections'
      path: '/mass-call-detections'
      fullPath: '/mass-call-detections'
      preLoaderRoute: typeof ShellMassCallDetectionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/mass-jobs': {
      id: '/_shell/mass-jobs'
      path: '/mass-jobs'
      fullPath: '/mass-jobs'
      preLoaderRoute: typeof ShellMassJobsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/messaging-profiles': {
      id: '/_shell/messaging-profiles'
      path: '/messaging-profiles'
      fullPath: '/messaging-profiles'
      preLoaderRoute: typeof ShellMessagingProfilesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/models': {
      id: '/_shell/models'
      path: '/models'
      fullPath: '/models'
      preLoaderRoute: typeof ShellModelsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/notifications': {
      id: '/_shell/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof ShellNotificationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/number-events': {
      id: '/_shell/number-events'
      path: '/number-events'
      fullPath: '/number-events'
      preLoaderRoute: typeof ShellNumberEventsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/number-orders': {
      id: '/_shell/number-orders'
      path: '/number-orders'
      fullPath: '/number-orders'
      preLoaderRoute: typeof ShellNumberOrdersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/numbers': {
      id: '/_shell/numbers'
      path: '/numbers'
      fullPath: '/numbers'
      preLoaderRoute: typeof ShellNumbersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/order-feedback': {
      id: '/_shell/order-feedback'
      path: '/order-feedback'
      fullPath: '/order-feedback'
      preLoaderRoute: typeof ShellOrderFeedbackRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders': {
      id: '/_shell/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof ShellOrdersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/org-ai': {
      id: '/_shell/org-ai'
      path: '/org-ai'
      fullPath: '/org-ai'
      preLoaderRoute: typeof ShellOrgAiRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/payment-methods': {
      id: '/_shell/payment-methods'
      path: '/payment-methods'
      fullPath: '/payment-methods'
      preLoaderRoute: typeof ShellPaymentMethodsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/payments': {
      id: '/_shell/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof ShellPaymentsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/plans': {
      id: '/_shell/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof ShellPlansRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/playground': {
      id: '/_shell/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof ShellPlaygroundRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/porting-orders': {
      id: '/_shell/porting-orders'
      path: '/porting-orders'
      fullPath: '/porting-orders'
      preLoaderRoute: typeof ShellPortingOrdersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/pricing-usage': {
      id: '/_shell/pricing-usage'
      path: '/pricing-usage'
      fullPath: '/pricing-usage'
      preLoaderRoute: typeof ShellPricingUsageRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/promotions': {
      id: '/_shell/promotions'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof ShellPromotionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/provider-switches': {
      id: '/_shell/provider-switches'
      path: '/provider-switches'
      fullPath: '/provider-switches'
      preLoaderRoute: typeof ShellProviderSwitchesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/quiet-hours': {
      id: '/_shell/quiet-hours'
      path: '/quiet-hours'
      fullPath: '/quiet-hours'
      preLoaderRoute: typeof ShellQuietHoursRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/quotes': {
      id: '/_shell/quotes'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof ShellQuotesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/security': {
      id: '/_shell/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof ShellSecurityRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/sender-health': {
      id: '/_shell/sender-health'
      path: '/sender-health'
      fullPath: '/sender-health'
      preLoaderRoute: typeof ShellSenderHealthRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/shipment-events': {
      id: '/_shell/shipment-events'
      path: '/shipment-events'
      fullPath: '/shipment-events'
      preLoaderRoute: typeof ShellShipmentEventsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/shipment-reasons': {
      id: '/_shell/shipment-reasons'
      path: '/shipment-reasons'
      fullPath: '/shipment-reasons'
      preLoaderRoute: typeof ShellShipmentReasonsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/sip': {
      id: '/_shell/sip'
      path: '/sip'
      fullPath: '/sip'
      preLoaderRoute: typeof ShellSipRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/skills': {
      id: '/_shell/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof ShellSkillsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/sms-messages': {
      id: '/_shell/sms-messages'
      path: '/sms-messages'
      fullPath: '/sms-messages'
      preLoaderRoute: typeof ShellSmsMessagesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/spam-controls': {
      id: '/_shell/spam-controls'
      path: '/spam-controls'
      fullPath: '/spam-controls'
      preLoaderRoute: typeof ShellSpamControlsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/speko-numbers': {
      id: '/_shell/speko-numbers'
      path: '/speko-numbers'
      fullPath: '/speko-numbers'
      preLoaderRoute: typeof ShellSpekoNumbersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/subscription-invoices': {
      id: '/_shell/subscription-invoices'
      path: '/subscription-invoices'
      fullPath: '/subscription-invoices'
      preLoaderRoute: typeof ShellSubscriptionInvoicesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/subscriptions': {
      id: '/_shell/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof ShellSubscriptionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tags': {
      id: '/_shell/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof ShellTagsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tasks': {
      id: '/_shell/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof ShellTasksRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/texting-automation': {
      id: '/_shell/texting-automation'
      path: '/texting-automation'
      fullPath: '/texting-automation'
      preLoaderRoute: typeof ShellTextingAutomationRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/thecargo-mail': {
      id: '/_shell/thecargo-mail'
      path: '/thecargo-mail'
      fullPath: '/thecargo-mail'
      preLoaderRoute: typeof ShellThecargoMailRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tip-presets': {
      id: '/_shell/tip-presets'
      path: '/tip-presets'
      fullPath: '/tip-presets'
      preLoaderRoute: typeof ShellTipPresetsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tools': {
      id: '/_shell/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof ShellToolsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/voices': {
      id: '/_shell/voices'
      path: '/voices'
      fullPath: '/voices'
      preLoaderRoute: typeof ShellVoicesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/voip': {
      id: '/_shell/voip'
      path: '/voip'
      fullPath: '/voip'
      preLoaderRoute: typeof ShellVoipRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/wallet-topups': {
      id: '/_shell/wallet-topups'
      path: '/wallet-topups'
      fullPath: '/wallet-topups'
      preLoaderRoute: typeof ShellWalletTopupsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/webhook-events': {
      id: '/_shell/webhook-events'
      path: '/webhook-events'
      fullPath: '/webhook-events'
      preLoaderRoute: typeof ShellWebhookEventsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/login_/passkey': {
      id: '/login_/passkey'
      path: '/login/passkey'
      fullPath: '/login/passkey'
      preLoaderRoute: typeof LoginPasskeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/recovery': {
      id: '/login_/recovery'
      path: '/login/recovery'
      fullPath: '/login/recovery'
      preLoaderRoute: typeof LoginRecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/ai-rates/': {
      id: '/_shell/ai-rates/'
      path: '/ai-rates'
      fullPath: '/ai-rates/'
      preLoaderRoute: typeof ShellAiRatesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/ai-rates/$rateId': {
      id: '/_shell/ai-rates/$rateId'
      path: '/ai-rates/$rateId'
      fullPath: '/ai-rates/$rateId'
      preLoaderRoute: typeof ShellAiRatesRateIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/announcements/': {
      id: '/_shell/announcements/'
      path: '/announcements'
      fullPath: '/announcements/'
      preLoaderRoute: typeof ShellAnnouncementsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/announcements/create': {
      id: '/_shell/announcements/create'
      path: '/announcements/create'
      fullPath: '/announcements/create'
      preLoaderRoute: typeof ShellAnnouncementsCreateRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/blog-posts/': {
      id: '/_shell/blog-posts/'
      path: '/blog-posts'
      fullPath: '/blog-posts/'
      preLoaderRoute: typeof ShellBlogPostsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/blog-posts/$postId': {
      id: '/_shell/blog-posts/$postId'
      path: '/blog-posts/$postId'
      fullPath: '/blog-posts/$postId'
      preLoaderRoute: typeof ShellBlogPostsPostIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/brokers/': {
      id: '/_shell/brokers/'
      path: '/brokers'
      fullPath: '/brokers/'
      preLoaderRoute: typeof ShellBrokersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/brokers/$usdot': {
      id: '/_shell/brokers/$usdot'
      path: '/brokers/$usdot'
      fullPath: '/brokers/$usdot'
      preLoaderRoute: typeof ShellBrokersUsdotRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/calls/': {
      id: '/_shell/calls/'
      path: '/calls'
      fullPath: '/calls/'
      preLoaderRoute: typeof ShellCallsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/calls/$callId': {
      id: '/_shell/calls/$callId'
      path: '/calls/$callId'
      fullPath: '/calls/$callId'
      preLoaderRoute: typeof ShellCallsCallIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/campaign/': {
      id: '/_shell/campaign/'
      path: '/'
      fullPath: '/campaign/'
      preLoaderRoute: typeof ShellCampaignIndexRouteImport
      parentRoute: typeof ShellCampaignRoute
    }
    '/_shell/campaign/$campaignId': {
      id: '/_shell/campaign/$campaignId'
      path: '/$campaignId'
      fullPath: '/campaign/$campaignId'
      preLoaderRoute: typeof ShellCampaignCampaignIdRouteImport
      parentRoute: typeof ShellCampaignRoute
    }
    '/_shell/carriers/': {
      id: '/_shell/carriers/'
      path: '/carriers'
      fullPath: '/carriers/'
      preLoaderRoute: typeof ShellCarriersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/carriers/$carrierId': {
      id: '/_shell/carriers/$carrierId'
      path: '/carriers/$carrierId'
      fullPath: '/carriers/$carrierId'
      preLoaderRoute: typeof ShellCarriersCarrierIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/contract-templates/': {
      id: '/_shell/contract-templates/'
      path: '/contract-templates'
      fullPath: '/contract-templates/'
      preLoaderRoute: typeof ShellContractTemplatesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/contract-templates/$templateId': {
      id: '/_shell/contract-templates/$templateId'
      path: '/contract-templates/$templateId'
      fullPath: '/contract-templates/$templateId'
      preLoaderRoute: typeof ShellContractTemplatesTemplateIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/customers/': {
      id: '/_shell/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof ShellCustomersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/customers/$customerId': {
      id: '/_shell/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof ShellCustomersCustomerIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/fmcsa-carriers/': {
      id: '/_shell/fmcsa-carriers/'
      path: '/fmcsa-carriers'
      fullPath: '/fmcsa-carriers/'
      preLoaderRoute: typeof ShellFmcsaCarriersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/fmcsa-carriers/$usdot': {
      id: '/_shell/fmcsa-carriers/$usdot'
      path: '/fmcsa-carriers/$usdot'
      fullPath: '/fmcsa-carriers/$usdot'
      preLoaderRoute: typeof ShellFmcsaCarriersUsdotRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/leads/$leadId': {
      id: '/_shell/leads/$leadId'
      path: '/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof ShellLeadsLeadIdRouteImport
      parentRoute: typeof ShellLeadsRoute
    }
    '/_shell/messaging-prices/': {
      id: '/_shell/messaging-prices/'
      path: '/messaging-prices'
      fullPath: '/messaging-prices/'
      preLoaderRoute: typeof ShellMessagingPricesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/messaging-prices/$priceId': {
      id: '/_shell/messaging-prices/$priceId'
      path: '/messaging-prices/$priceId'
      fullPath: '/messaging-prices/$priceId'
      preLoaderRoute: typeof ShellMessagingPricesPriceIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders/$orderId': {
      id: '/_shell/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof ShellOrdersOrderIdRouteImport
      parentRoute: typeof ShellOrdersRoute
    }
    '/_shell/organizations/': {
      id: '/_shell/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof ShellOrganizationsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/organizations/$organizationId': {
      id: '/_shell/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof ShellOrganizationsOrganizationIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/providers/': {
      id: '/_shell/providers/'
      path: '/providers'
      fullPath: '/providers/'
      preLoaderRoute: typeof ShellProvidersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/providers/$providerId': {
      id: '/_shell/providers/$providerId'
      path: '/providers/$providerId'
      fullPath: '/providers/$providerId'
      preLoaderRoute: typeof ShellProvidersProviderIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/quotes/$quoteId': {
      id: '/_shell/quotes/$quoteId'
      path: '/$quoteId'
      fullPath: '/quotes/$quoteId'
      preLoaderRoute: typeof ShellQuotesQuoteIdRouteImport
      parentRoute: typeof ShellQuotesRoute
    }
    '/_shell/role-templates/': {
      id: '/_shell/role-templates/'
      path: '/role-templates'
      fullPath: '/role-templates/'
      preLoaderRoute: typeof ShellRoleTemplatesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/role-templates/$templateId': {
      id: '/_shell/role-templates/$templateId'
      path: '/role-templates/$templateId'
      fullPath: '/role-templates/$templateId'
      preLoaderRoute: typeof ShellRoleTemplatesTemplateIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/roles/': {
      id: '/_shell/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof ShellRolesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/roles/$roleId': {
      id: '/_shell/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof ShellRolesRoleIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/shipments/': {
      id: '/_shell/shipments/'
      path: '/shipments'
      fullPath: '/shipments/'
      preLoaderRoute: typeof ShellShipmentsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/shipments/$shipmentId': {
      id: '/_shell/shipments/$shipmentId'
      path: '/shipments/$shipmentId'
      fullPath: '/shipments/$shipmentId'
      preLoaderRoute: typeof ShellShipmentsShipmentIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/teams/': {
      id: '/_shell/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof ShellTeamsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/teams/$teamId': {
      id: '/_shell/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof ShellTeamsTeamIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/users/': {
      id: '/_shell/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof ShellUsersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/users/$userId': {
      id: '/_shell/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof ShellUsersUserIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/leads/$leadId/': {
      id: '/_shell/leads/$leadId/'
      path: '/'
      fullPath: '/leads/$leadId/'
      preLoaderRoute: typeof ShellLeadsLeadIdIndexRouteImport
      parentRoute: typeof ShellLeadsLeadIdRoute
    }
    '/_shell/leads/$leadId/convert': {
      id: '/_shell/leads/$leadId/convert'
      path: '/convert'
      fullPath: '/leads/$leadId/convert'
      preLoaderRoute: typeof ShellLeadsLeadIdConvertRouteImport
      parentRoute: typeof ShellLeadsLeadIdRoute
    }
    '/_shell/leads/$leadId/edit': {
      id: '/_shell/leads/$leadId/edit'
      path: '/edit'
      fullPath: '/leads/$leadId/edit'
      preLoaderRoute: typeof ShellLeadsLeadIdEditRouteImport
      parentRoute: typeof ShellLeadsLeadIdRoute
    }
    '/_shell/orders/$orderId/': {
      id: '/_shell/orders/$orderId/'
      path: '/'
      fullPath: '/orders/$orderId/'
      preLoaderRoute: typeof ShellOrdersOrderIdIndexRouteImport
      parentRoute: typeof ShellOrdersOrderIdRoute
    }
    '/_shell/orders/$orderId/dispatch': {
      id: '/_shell/orders/$orderId/dispatch'
      path: '/dispatch'
      fullPath: '/orders/$orderId/dispatch'
      preLoaderRoute: typeof ShellOrdersOrderIdDispatchRouteImport
      parentRoute: typeof ShellOrdersOrderIdRoute
    }
    '/_shell/orders/$orderId/edit': {
      id: '/_shell/orders/$orderId/edit'
      path: '/edit'
      fullPath: '/orders/$orderId/edit'
      preLoaderRoute: typeof ShellOrdersOrderIdEditRouteImport
      parentRoute: typeof ShellOrdersOrderIdRoute
    }
    '/_shell/organizations/$organizationId_/edit': {
      id: '/_shell/organizations/$organizationId_/edit'
      path: '/organizations/$organizationId/edit'
      fullPath: '/organizations/$organizationId/edit'
      preLoaderRoute: typeof ShellOrganizationsOrganizationIdEditRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/quotes/$quoteId/': {
      id: '/_shell/quotes/$quoteId/'
      path: '/'
      fullPath: '/quotes/$quoteId/'
      preLoaderRoute: typeof ShellQuotesQuoteIdIndexRouteImport
      parentRoute: typeof ShellQuotesQuoteIdRoute
    }
    '/_shell/quotes/$quoteId/convert': {
      id: '/_shell/quotes/$quoteId/convert'
      path: '/convert'
      fullPath: '/quotes/$quoteId/convert'
      preLoaderRoute: typeof ShellQuotesQuoteIdConvertRouteImport
      parentRoute: typeof ShellQuotesQuoteIdRoute
    }
    '/_shell/quotes/$quoteId/edit': {
      id: '/_shell/quotes/$quoteId/edit'
      path: '/edit'
      fullPath: '/quotes/$quoteId/edit'
      preLoaderRoute: typeof ShellQuotesQuoteIdEditRouteImport
      parentRoute: typeof ShellQuotesQuoteIdRoute
    }
    '/_shell/shipments_/$shipmentId/edit': {
      id: '/_shell/shipments_/$shipmentId/edit'
      path: '/shipments/$shipmentId/edit'
      fullPath: '/shipments/$shipmentId/edit'
      preLoaderRoute: typeof ShellShipmentsShipmentIdEditRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellCampaignRouteChildren {
  ShellCampaignCampaignIdRoute: typeof ShellCampaignCampaignIdRoute
  ShellCampaignIndexRoute: typeof ShellCampaignIndexRoute
}

const ShellCampaignRouteChildren: ShellCampaignRouteChildren = {
  ShellCampaignCampaignIdRoute: ShellCampaignCampaignIdRoute,
  ShellCampaignIndexRoute: ShellCampaignIndexRoute,
}

const ShellCampaignRouteWithChildren = ShellCampaignRoute._addFileChildren(
  ShellCampaignRouteChildren,
)

interface ShellLeadsLeadIdRouteChildren {
  ShellLeadsLeadIdConvertRoute: typeof ShellLeadsLeadIdConvertRoute
  ShellLeadsLeadIdEditRoute: typeof ShellLeadsLeadIdEditRoute
  ShellLeadsLeadIdIndexRoute: typeof ShellLeadsLeadIdIndexRoute
}

const ShellLeadsLeadIdRouteChildren: ShellLeadsLeadIdRouteChildren = {
  ShellLeadsLeadIdConvertRoute: ShellLeadsLeadIdConvertRoute,
  ShellLeadsLeadIdEditRoute: ShellLeadsLeadIdEditRoute,
  ShellLeadsLeadIdIndexRoute: ShellLeadsLeadIdIndexRoute,
}

const ShellLeadsLeadIdRouteWithChildren =
  ShellLeadsLeadIdRoute._addFileChildren(ShellLeadsLeadIdRouteChildren)

interface ShellLeadsRouteChildren {
  ShellLeadsLeadIdRoute: typeof ShellLeadsLeadIdRouteWithChildren
}

const ShellLeadsRouteChildren: ShellLeadsRouteChildren = {
  ShellLeadsLeadIdRoute: ShellLeadsLeadIdRouteWithChildren,
}

const ShellLeadsRouteWithChildren = ShellLeadsRoute._addFileChildren(
  ShellLeadsRouteChildren,
)

interface ShellOrdersOrderIdRouteChildren {
  ShellOrdersOrderIdDispatchRoute: typeof ShellOrdersOrderIdDispatchRoute
  ShellOrdersOrderIdEditRoute: typeof ShellOrdersOrderIdEditRoute
  ShellOrdersOrderIdIndexRoute: typeof ShellOrdersOrderIdIndexRoute
}

const ShellOrdersOrderIdRouteChildren: ShellOrdersOrderIdRouteChildren = {
  ShellOrdersOrderIdDispatchRoute: ShellOrdersOrderIdDispatchRoute,
  ShellOrdersOrderIdEditRoute: ShellOrdersOrderIdEditRoute,
  ShellOrdersOrderIdIndexRoute: ShellOrdersOrderIdIndexRoute,
}

const ShellOrdersOrderIdRouteWithChildren =
  ShellOrdersOrderIdRoute._addFileChildren(ShellOrdersOrderIdRouteChildren)

interface ShellOrdersRouteChildren {
  ShellOrdersOrderIdRoute: typeof ShellOrdersOrderIdRouteWithChildren
}

const ShellOrdersRouteChildren: ShellOrdersRouteChildren = {
  ShellOrdersOrderIdRoute: ShellOrdersOrderIdRouteWithChildren,
}

const ShellOrdersRouteWithChildren = ShellOrdersRoute._addFileChildren(
  ShellOrdersRouteChildren,
)

interface ShellQuotesQuoteIdRouteChildren {
  ShellQuotesQuoteIdConvertRoute: typeof ShellQuotesQuoteIdConvertRoute
  ShellQuotesQuoteIdEditRoute: typeof ShellQuotesQuoteIdEditRoute
  ShellQuotesQuoteIdIndexRoute: typeof ShellQuotesQuoteIdIndexRoute
}

const ShellQuotesQuoteIdRouteChildren: ShellQuotesQuoteIdRouteChildren = {
  ShellQuotesQuoteIdConvertRoute: ShellQuotesQuoteIdConvertRoute,
  ShellQuotesQuoteIdEditRoute: ShellQuotesQuoteIdEditRoute,
  ShellQuotesQuoteIdIndexRoute: ShellQuotesQuoteIdIndexRoute,
}

const ShellQuotesQuoteIdRouteWithChildren =
  ShellQuotesQuoteIdRoute._addFileChildren(ShellQuotesQuoteIdRouteChildren)

interface ShellQuotesRouteChildren {
  ShellQuotesQuoteIdRoute: typeof ShellQuotesQuoteIdRouteWithChildren
}

const ShellQuotesRouteChildren: ShellQuotesRouteChildren = {
  ShellQuotesQuoteIdRoute: ShellQuotesQuoteIdRouteWithChildren,
}

const ShellQuotesRouteWithChildren = ShellQuotesRoute._addFileChildren(
  ShellQuotesRouteChildren,
)

interface ShellRouteChildren {
  ShellAdminsRoute: typeof ShellAdminsRoute
  ShellAgentsRoute: typeof ShellAgentsRoute
  ShellAiCostsRoute: typeof ShellAiCostsRoute
  ShellAnnouncementBarRoute: typeof ShellAnnouncementBarRoute
  ShellAuditRoute: typeof ShellAuditRoute
  ShellAutomationsRoute: typeof ShellAutomationsRoute
  ShellBillingRulesRoute: typeof ShellBillingRulesRoute
  ShellBrandsRoute: typeof ShellBrandsRoute
  ShellBrokerChangesRoute: typeof ShellBrokerChangesRoute
  ShellBrokerOverviewRoute: typeof ShellBrokerOverviewRoute
  ShellBrokerSyncRoute: typeof ShellBrokerSyncRoute
  ShellCampaignRoute: typeof ShellCampaignRouteWithChildren
  ShellCampaignsRoute: typeof ShellCampaignsRoute
  ShellCarrierReconcileRoute: typeof ShellCarrierReconcileRoute
  ShellChangelogsRoute: typeof ShellChangelogsRoute
  ShellCheckRateRoute: typeof ShellCheckRateRoute
  ShellCommFilesRoute: typeof ShellCommFilesRoute
  ShellCommTemplatesRoute: typeof ShellCommTemplatesRoute
  ShellCommunicationsRoute: typeof ShellCommunicationsRoute
  ShellContactConsentsRoute: typeof ShellContactConsentsRoute
  ShellConversationsRoute: typeof ShellConversationsRoute
  ShellCredentialGroupsRoute: typeof ShellCredentialGroupsRoute
  ShellCreditCardsRoute: typeof ShellCreditCardsRoute
  ShellDeliverabilityRoute: typeof ShellDeliverabilityRoute
  ShellDispatchesRoute: typeof ShellDispatchesRoute
  ShellDistributionsRoute: typeof ShellDistributionsRoute
  ShellEmailMessagesRoute: typeof ShellEmailMessagesRoute
  ShellGeocodesRoute: typeof ShellGeocodesRoute
  ShellGroupLoadboardRoute: typeof ShellGroupLoadboardRoute
  ShellGroupSubscriptionsRoute: typeof ShellGroupSubscriptionsRoute
  ShellHomeRoute: typeof ShellHomeRoute
  ShellImportRoute: typeof ShellImportRoute
  ShellInboxRoute: typeof ShellInboxRoute
  ShellInboxesRoute: typeof ShellInboxesRoute
  ShellInsightsRoute: typeof ShellInsightsRoute
  ShellIntegrationsRoute: typeof ShellIntegrationsRoute
  ShellLeadSubmissionsRoute: typeof ShellLeadSubmissionsRoute
  ShellLeadsRoute: typeof ShellLeadsRouteWithChildren
  ShellLoadboardsRoute: typeof ShellLoadboardsRoute
  ShellLogsRoute: typeof ShellLogsRoute
  ShellMailAccountsRoute: typeof ShellMailAccountsRoute
  ShellMailPricingRoute: typeof ShellMailPricingRoute
  ShellMailSettingsRoute: typeof ShellMailSettingsRoute
  ShellMassCallDetectionsRoute: typeof ShellMassCallDetectionsRoute
  ShellMassJobsRoute: typeof ShellMassJobsRoute
  ShellMessagingProfilesRoute: typeof ShellMessagingProfilesRoute
  ShellModelsRoute: typeof ShellModelsRoute
  ShellNotificationsRoute: typeof ShellNotificationsRoute
  ShellNumberEventsRoute: typeof ShellNumberEventsRoute
  ShellNumberOrdersRoute: typeof ShellNumberOrdersRoute
  ShellNumbersRoute: typeof ShellNumbersRoute
  ShellOrderFeedbackRoute: typeof ShellOrderFeedbackRoute
  ShellOrdersRoute: typeof ShellOrdersRouteWithChildren
  ShellOrgAiRoute: typeof ShellOrgAiRoute
  ShellPaymentMethodsRoute: typeof ShellPaymentMethodsRoute
  ShellPaymentsRoute: typeof ShellPaymentsRoute
  ShellPlansRoute: typeof ShellPlansRoute
  ShellPlaygroundRoute: typeof ShellPlaygroundRoute
  ShellPortingOrdersRoute: typeof ShellPortingOrdersRoute
  ShellPricingUsageRoute: typeof ShellPricingUsageRoute
  ShellPromotionsRoute: typeof ShellPromotionsRoute
  ShellProviderSwitchesRoute: typeof ShellProviderSwitchesRoute
  ShellQuietHoursRoute: typeof ShellQuietHoursRoute
  ShellQuotesRoute: typeof ShellQuotesRouteWithChildren
  ShellSecurityRoute: typeof ShellSecurityRoute
  ShellSenderHealthRoute: typeof ShellSenderHealthRoute
  ShellShipmentEventsRoute: typeof ShellShipmentEventsRoute
  ShellShipmentReasonsRoute: typeof ShellShipmentReasonsRoute
  ShellSipRoute: typeof ShellSipRoute
  ShellSkillsRoute: typeof ShellSkillsRoute
  ShellSmsMessagesRoute: typeof ShellSmsMessagesRoute
  ShellSpamControlsRoute: typeof ShellSpamControlsRoute
  ShellSpekoNumbersRoute: typeof ShellSpekoNumbersRoute
  ShellSubscriptionInvoicesRoute: typeof ShellSubscriptionInvoicesRoute
  ShellSubscriptionsRoute: typeof ShellSubscriptionsRoute
  ShellTagsRoute: typeof ShellTagsRoute
  ShellTasksRoute: typeof ShellTasksRoute
  ShellTextingAutomationRoute: typeof ShellTextingAutomationRoute
  ShellThecargoMailRoute: typeof ShellThecargoMailRoute
  ShellTipPresetsRoute: typeof ShellTipPresetsRoute
  ShellToolsRoute: typeof ShellToolsRoute
  ShellVoicesRoute: typeof ShellVoicesRoute
  ShellVoipRoute: typeof ShellVoipRoute
  ShellWalletTopupsRoute: typeof ShellWalletTopupsRoute
  ShellWebhookEventsRoute: typeof ShellWebhookEventsRoute
  ShellIndexRoute: typeof ShellIndexRoute
  ShellAiRatesRateIdRoute: typeof ShellAiRatesRateIdRoute
  ShellAnnouncementsCreateRoute: typeof ShellAnnouncementsCreateRoute
  ShellBlogPostsPostIdRoute: typeof ShellBlogPostsPostIdRoute
  ShellBrokersUsdotRoute: typeof ShellBrokersUsdotRoute
  ShellCallsCallIdRoute: typeof ShellCallsCallIdRoute
  ShellCarriersCarrierIdRoute: typeof ShellCarriersCarrierIdRoute
  ShellContractTemplatesTemplateIdRoute: typeof ShellContractTemplatesTemplateIdRoute
  ShellCustomersCustomerIdRoute: typeof ShellCustomersCustomerIdRoute
  ShellFmcsaCarriersUsdotRoute: typeof ShellFmcsaCarriersUsdotRoute
  ShellMessagingPricesPriceIdRoute: typeof ShellMessagingPricesPriceIdRoute
  ShellOrganizationsOrganizationIdRoute: typeof ShellOrganizationsOrganizationIdRoute
  ShellProvidersProviderIdRoute: typeof ShellProvidersProviderIdRoute
  ShellRoleTemplatesTemplateIdRoute: typeof ShellRoleTemplatesTemplateIdRoute
  ShellRolesRoleIdRoute: typeof ShellRolesRoleIdRoute
  ShellShipmentsShipmentIdRoute: typeof ShellShipmentsShipmentIdRoute
  ShellTeamsTeamIdRoute: typeof ShellTeamsTeamIdRoute
  ShellUsersUserIdRoute: typeof ShellUsersUserIdRoute
  ShellAiRatesIndexRoute: typeof ShellAiRatesIndexRoute
  ShellAnnouncementsIndexRoute: typeof ShellAnnouncementsIndexRoute
  ShellBlogPostsIndexRoute: typeof ShellBlogPostsIndexRoute
  ShellBrokersIndexRoute: typeof ShellBrokersIndexRoute
  ShellCallsIndexRoute: typeof ShellCallsIndexRoute
  ShellCarriersIndexRoute: typeof ShellCarriersIndexRoute
  ShellContractTemplatesIndexRoute: typeof ShellContractTemplatesIndexRoute
  ShellCustomersIndexRoute: typeof ShellCustomersIndexRoute
  ShellFmcsaCarriersIndexRoute: typeof ShellFmcsaCarriersIndexRoute
  ShellMessagingPricesIndexRoute: typeof ShellMessagingPricesIndexRoute
  ShellOrganizationsIndexRoute: typeof ShellOrganizationsIndexRoute
  ShellProvidersIndexRoute: typeof ShellProvidersIndexRoute
  ShellRoleTemplatesIndexRoute: typeof ShellRoleTemplatesIndexRoute
  ShellRolesIndexRoute: typeof ShellRolesIndexRoute
  ShellShipmentsIndexRoute: typeof ShellShipmentsIndexRoute
  ShellTeamsIndexRoute: typeof ShellTeamsIndexRoute
  ShellUsersIndexRoute: typeof ShellUsersIndexRoute
  ShellOrganizationsOrganizationIdEditRoute: typeof ShellOrganizationsOrganizationIdEditRoute
  ShellShipmentsShipmentIdEditRoute: typeof ShellShipmentsShipmentIdEditRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellAdminsRoute: ShellAdminsRoute,
  ShellAgentsRoute: ShellAgentsRoute,
  ShellAiCostsRoute: ShellAiCostsRoute,
  ShellAnnouncementBarRoute: ShellAnnouncementBarRoute,
  ShellAuditRoute: ShellAuditRoute,
  ShellAutomationsRoute: ShellAutomationsRoute,
  ShellBillingRulesRoute: ShellBillingRulesRoute,
  ShellBrandsRoute: ShellBrandsRoute,
  ShellBrokerChangesRoute: ShellBrokerChangesRoute,
  ShellBrokerOverviewRoute: ShellBrokerOverviewRoute,
  ShellBrokerSyncRoute: ShellBrokerSyncRoute,
  ShellCampaignRoute: ShellCampaignRouteWithChildren,
  ShellCampaignsRoute: ShellCampaignsRoute,
  ShellCarrierReconcileRoute: ShellCarrierReconcileRoute,
  ShellChangelogsRoute: ShellChangelogsRoute,
  ShellCheckRateRoute: ShellCheckRateRoute,
  ShellCommFilesRoute: ShellCommFilesRoute,
  ShellCommTemplatesRoute: ShellCommTemplatesRoute,
  ShellCommunicationsRoute: ShellCommunicationsRoute,
  ShellContactConsentsRoute: ShellContactConsentsRoute,
  ShellConversationsRoute: ShellConversationsRoute,
  ShellCredentialGroupsRoute: ShellCredentialGroupsRoute,
  ShellCreditCardsRoute: ShellCreditCardsRoute,
  ShellDeliverabilityRoute: ShellDeliverabilityRoute,
  ShellDispatchesRoute: ShellDispatchesRoute,
  ShellDistributionsRoute: ShellDistributionsRoute,
  ShellEmailMessagesRoute: ShellEmailMessagesRoute,
  ShellGeocodesRoute: ShellGeocodesRoute,
  ShellGroupLoadboardRoute: ShellGroupLoadboardRoute,
  ShellGroupSubscriptionsRoute: ShellGroupSubscriptionsRoute,
  ShellHomeRoute: ShellHomeRoute,
  ShellImportRoute: ShellImportRoute,
  ShellInboxRoute: ShellInboxRoute,
  ShellInboxesRoute: ShellInboxesRoute,
  ShellInsightsRoute: ShellInsightsRoute,
  ShellIntegrationsRoute: ShellIntegrationsRoute,
  ShellLeadSubmissionsRoute: ShellLeadSubmissionsRoute,
  ShellLeadsRoute: ShellLeadsRouteWithChildren,
  ShellLoadboardsRoute: ShellLoadboardsRoute,
  ShellLogsRoute: ShellLogsRoute,
  ShellMailAccountsRoute: ShellMailAccountsRoute,
  ShellMailPricingRoute: ShellMailPricingRoute,
  ShellMailSettingsRoute: ShellMailSettingsRoute,
  ShellMassCallDetectionsRoute: ShellMassCallDetectionsRoute,
  ShellMassJobsRoute: ShellMassJobsRoute,
  ShellMessagingProfilesRoute: ShellMessagingProfilesRoute,
  ShellModelsRoute: ShellModelsRoute,
  ShellNotificationsRoute: ShellNotificationsRoute,
  ShellNumberEventsRoute: ShellNumberEventsRoute,
  ShellNumberOrdersRoute: ShellNumberOrdersRoute,
  ShellNumbersRoute: ShellNumbersRoute,
  ShellOrderFeedbackRoute: ShellOrderFeedbackRoute,
  ShellOrdersRoute: ShellOrdersRouteWithChildren,
  ShellOrgAiRoute: ShellOrgAiRoute,
  ShellPaymentMethodsRoute: ShellPaymentMethodsRoute,
  ShellPaymentsRoute: ShellPaymentsRoute,
  ShellPlansRoute: ShellPlansRoute,
  ShellPlaygroundRoute: ShellPlaygroundRoute,
  ShellPortingOrdersRoute: ShellPortingOrdersRoute,
  ShellPricingUsageRoute: ShellPricingUsageRoute,
  ShellPromotionsRoute: ShellPromotionsRoute,
  ShellProviderSwitchesRoute: ShellProviderSwitchesRoute,
  ShellQuietHoursRoute: ShellQuietHoursRoute,
  ShellQuotesRoute: ShellQuotesRouteWithChildren,
  ShellSecurityRoute: ShellSecurityRoute,
  ShellSenderHealthRoute: ShellSenderHealthRoute,
  ShellShipmentEventsRoute: ShellShipmentEventsRoute,
  ShellShipmentReasonsRoute: ShellShipmentReasonsRoute,
  ShellSipRoute: ShellSipRoute,
  ShellSkillsRoute: ShellSkillsRoute,
  ShellSmsMessagesRoute: ShellSmsMessagesRoute,
  ShellSpamControlsRoute: ShellSpamControlsRoute,
  ShellSpekoNumbersRoute: ShellSpekoNumbersRoute,
  ShellSubscriptionInvoicesRoute: ShellSubscriptionInvoicesRoute,
  ShellSubscriptionsRoute: ShellSubscriptionsRoute,
  ShellTagsRoute: ShellTagsRoute,
  ShellTasksRoute: ShellTasksRoute,
  ShellTextingAutomationRoute: ShellTextingAutomationRoute,
  ShellThecargoMailRoute: ShellThecargoMailRoute,
  ShellTipPresetsRoute: ShellTipPresetsRoute,
  ShellToolsRoute: ShellToolsRoute,
  ShellVoicesRoute: ShellVoicesRoute,
  ShellVoipRoute: ShellVoipRoute,
  ShellWalletTopupsRoute: ShellWalletTopupsRoute,
  ShellWebhookEventsRoute: ShellWebhookEventsRoute,
  ShellIndexRoute: ShellIndexRoute,
  ShellAiRatesRateIdRoute: ShellAiRatesRateIdRoute,
  ShellAnnouncementsCreateRoute: ShellAnnouncementsCreateRoute,
  ShellBlogPostsPostIdRoute: ShellBlogPostsPostIdRoute,
  ShellBrokersUsdotRoute: ShellBrokersUsdotRoute,
  ShellCallsCallIdRoute: ShellCallsCallIdRoute,
  ShellCarriersCarrierIdRoute: ShellCarriersCarrierIdRoute,
  ShellContractTemplatesTemplateIdRoute: ShellContractTemplatesTemplateIdRoute,
  ShellCustomersCustomerIdRoute: ShellCustomersCustomerIdRoute,
  ShellFmcsaCarriersUsdotRoute: ShellFmcsaCarriersUsdotRoute,
  ShellMessagingPricesPriceIdRoute: ShellMessagingPricesPriceIdRoute,
  ShellOrganizationsOrganizationIdRoute: ShellOrganizationsOrganizationIdRoute,
  ShellProvidersProviderIdRoute: ShellProvidersProviderIdRoute,
  ShellRoleTemplatesTemplateIdRoute: ShellRoleTemplatesTemplateIdRoute,
  ShellRolesRoleIdRoute: ShellRolesRoleIdRoute,
  ShellShipmentsShipmentIdRoute: ShellShipmentsShipmentIdRoute,
  ShellTeamsTeamIdRoute: ShellTeamsTeamIdRoute,
  ShellUsersUserIdRoute: ShellUsersUserIdRoute,
  ShellAiRatesIndexRoute: ShellAiRatesIndexRoute,
  ShellAnnouncementsIndexRoute: ShellAnnouncementsIndexRoute,
  ShellBlogPostsIndexRoute: ShellBlogPostsIndexRoute,
  ShellBrokersIndexRoute: ShellBrokersIndexRoute,
  ShellCallsIndexRoute: ShellCallsIndexRoute,
  ShellCarriersIndexRoute: ShellCarriersIndexRoute,
  ShellContractTemplatesIndexRoute: ShellContractTemplatesIndexRoute,
  ShellCustomersIndexRoute: ShellCustomersIndexRoute,
  ShellFmcsaCarriersIndexRoute: ShellFmcsaCarriersIndexRoute,
  ShellMessagingPricesIndexRoute: ShellMessagingPricesIndexRoute,
  ShellOrganizationsIndexRoute: ShellOrganizationsIndexRoute,
  ShellProvidersIndexRoute: ShellProvidersIndexRoute,
  ShellRoleTemplatesIndexRoute: ShellRoleTemplatesIndexRoute,
  ShellRolesIndexRoute: ShellRolesIndexRoute,
  ShellShipmentsIndexRoute: ShellShipmentsIndexRoute,
  ShellTeamsIndexRoute: ShellTeamsIndexRoute,
  ShellUsersIndexRoute: ShellUsersIndexRoute,
  ShellOrganizationsOrganizationIdEditRoute:
    ShellOrganizationsOrganizationIdEditRoute,
  ShellShipmentsShipmentIdEditRoute: ShellShipmentsShipmentIdEditRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ShellRoute: ShellRouteWithChildren,
  LoginRoute: LoginRoute,
  LoginPasskeyRoute: LoginPasskeyRoute,
  LoginRecoveryRoute: LoginRecoveryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
